const TAX_RATE_LIST =new Map( [
  [71937,{
    ZipCode: 71937,
    TaxRegionName: "MCCURTAIN",
    EstimatedCombinedRate: 0.0625,
  }],

  [71953,{
    ZipCode: 71953,
    TaxRegionName: "MAJOR",
    EstimatedCombinedRate: 0.0625,
  }],

  [73001,{
    ZipCode: 73001,
    TaxRegionName: "CADDO",
    EstimatedCombinedRate: 0.06,
  }],

  [73002,{
    ZipCode: 73002,
    TaxRegionName: "DIBBLE",
    EstimatedCombinedRate: 0.1,
  }],

  [73003,{
    ZipCode: 73003,
    TaxRegionName: "OKLAHOMA CITY",
    EstimatedCombinedRate: 0.08625,
  }],

  [73004,{
    ZipCode: 73004,
    TaxRegionName: "AMBER",
    EstimatedCombinedRate: 0.0925,
  }],

  [73005,{
    ZipCode: 73005,
    TaxRegionName: "GRACEMONT",
    EstimatedCombinedRate: 0.1,
  }],

  [73006,{
    ZipCode: 73006,
    TaxRegionName: "APACHE",
    EstimatedCombinedRate: 0.095,
  }],

  [73007,{
    ZipCode: 73007,
    TaxRegionName: "OKLAHOMA CITY",
    EstimatedCombinedRate: 0.08625,
  }],

  [73008,{
    ZipCode: 73008,
    TaxRegionName: "OKLAHOMA CITY",
    EstimatedCombinedRate: 0.08625,
  }],

  [73009,{
    ZipCode: 73009,
    TaxRegionName: "BINGER",
    EstimatedCombinedRate: 0.1,
  }],

  [73010,{
    ZipCode: 73010,
    TaxRegionName: "DIBBLE",
    EstimatedCombinedRate: 0.1,
  }],

  [73011,{
    ZipCode: 73011,
    TaxRegionName: "ALEX",
    EstimatedCombinedRate: 0.0825,
  }],

  [73012,{
    ZipCode: 73012,
    TaxRegionName: "OKLAHOMA CITY",
    EstimatedCombinedRate: 0.08625,
  }],

  [73013,{
    ZipCode: 73013,
    TaxRegionName: "OKLAHOMA CITY",
    EstimatedCombinedRate: 0.08625,
  }],

  [73014,{
    ZipCode: 73014,
    TaxRegionName: "CALUMET",
    EstimatedCombinedRate: 0.0885,
  }],

  [73015,{
    ZipCode: 73015,
    TaxRegionName: "CARNEGIE",
    EstimatedCombinedRate: 0.1,
  }],

  [73016,{
    ZipCode: 73016,
    TaxRegionName: "CASHION",
    EstimatedCombinedRate: 0.0975,
  }],

  [73017,{
    ZipCode: 73017,
    TaxRegionName: "CEMENT",
    EstimatedCombinedRate: 0.095,
  }],

  [73018,{
    ZipCode: 73018,
    TaxRegionName: "CHICKASHA",
    EstimatedCombinedRate: 0.09,
  }],

  [73019,{
    ZipCode: 73019,
    TaxRegionName: "NORMAN",
    EstimatedCombinedRate: 0.0875,
  }],

  [73020,{
    ZipCode: 73020,
    TaxRegionName: "JONES",
    EstimatedCombinedRate: 0.095,
  }],

  [73021,{
    ZipCode: 73021,
    TaxRegionName: "COLONY",
    EstimatedCombinedRate: 0.085,
  }],

  [73022,{
    ZipCode: 73022,
    TaxRegionName: "EL RENO",
    EstimatedCombinedRate: 0.0885,
  }],

  [73023,{
    ZipCode: 73023,
    TaxRegionName: "CHICKASHA",
    EstimatedCombinedRate: 0.09,
  }],

  [73024,{
    ZipCode: 73024,
    TaxRegionName: "CORN",
    EstimatedCombinedRate: 0.085,
  }],

  [73025,{
    ZipCode: 73025,
    TaxRegionName: "EDMOND",
    EstimatedCombinedRate: 0.085,
  }],

  [73026,{
    ZipCode: 73026,
    TaxRegionName: "PINK",
    EstimatedCombinedRate: 0.08995,
  }],

  [73027,{
    ZipCode: 73027,
    TaxRegionName: "LANGSTON",
    EstimatedCombinedRate: 0.0925,
  }],

  [73028,{
    ZipCode: 73028,
    TaxRegionName: "CRESCENT",
    EstimatedCombinedRate: 0.0825,
  }],

  [73029,{
    ZipCode: 73029,
    TaxRegionName: "CYRIL",
    EstimatedCombinedRate: 0.1,
  }],

  [73030,{
    ZipCode: 73030,
    TaxRegionName: "DAVIS",
    EstimatedCombinedRate: 0.095,
  }],

  [73031,{
    ZipCode: 73031,
    TaxRegionName: "DIBBLE",
    EstimatedCombinedRate: 0.1,
  }],

  [73032,{
    ZipCode: 73032,
    TaxRegionName: "DOUGHERTY",
    EstimatedCombinedRate: 0.085,
  }],

  [73033,{
    ZipCode: 73033,
    TaxRegionName: "EAKLY",
    EstimatedCombinedRate: 0.09,
  }],

  [73034,{
    ZipCode: 73034,
    TaxRegionName: "EDMOND",
    EstimatedCombinedRate: 0.085,
  }],

  [73036,{
    ZipCode: 73036,
    TaxRegionName: "OKLAHOMA CITY",
    EstimatedCombinedRate: 0.08975,
  }],

  [73038,{
    ZipCode: 73038,
    TaxRegionName: "FORT COBB",
    EstimatedCombinedRate: 0.1,
  }],

  [73039,{
    ZipCode: 73039,
    TaxRegionName: "DAVIS",
    EstimatedCombinedRate: 0.095,
  }],

  [73040,{
    ZipCode: 73040,
    TaxRegionName: "GEARY",
    EstimatedCombinedRate: 0.08875,
  }],

  [73041,{
    ZipCode: 73041,
    TaxRegionName: "GOTEBO",
    EstimatedCombinedRate: 0.09,
  }],

  [73042,{
    ZipCode: 73042,
    TaxRegionName: "GRACEMONT",
    EstimatedCombinedRate: 0.1,
  }],

  [73043,{
    ZipCode: 73043,
    TaxRegionName: "GREENFIELD",
    EstimatedCombinedRate: 0.08375,
  }],

  [73044,{
    ZipCode: 73044,
    TaxRegionName: "LANGSTON",
    EstimatedCombinedRate: 0.0925,
  }],

  [73045,{
    ZipCode: 73045,
    TaxRegionName: "OKLAHOMA CITY",
    EstimatedCombinedRate: 0.08625,
  }],

  [73047,{
    ZipCode: 73047,
    TaxRegionName: "BRIDGEPORT",
    EstimatedCombinedRate: 0.09,
  }],

  [73048,{
    ZipCode: 73048,
    TaxRegionName: "HYDRO",
    EstimatedCombinedRate: 0.105,
  }],

  [73049,{
    ZipCode: 73049,
    TaxRegionName: "JONES",
    EstimatedCombinedRate: 0.095,
  }],

  [73050,{
    ZipCode: 73050,
    TaxRegionName: "LANGSTON",
    EstimatedCombinedRate: 0.0925,
  }],

  [73051,{
    ZipCode: 73051,
    TaxRegionName: "PURCELL",
    EstimatedCombinedRate: 0.09625,
  }],

  [73052,{
    ZipCode: 73052,
    TaxRegionName: "DIBBLE",
    EstimatedCombinedRate: 0.1,
  }],

  [73053,{
    ZipCode: 73053,
    TaxRegionName: "LOOKEBA",
    EstimatedCombinedRate: 0.09,
  }],

  [73054,{
    ZipCode: 73054,
    TaxRegionName: "OKLAHOMA CITY",
    EstimatedCombinedRate: 0.08625,
  }],

  [73055,{
    ZipCode: 73055,
    TaxRegionName: "DUNCAN",
    EstimatedCombinedRate: 0.087,
  }],

  [73056,{
    ZipCode: 73056,
    TaxRegionName: "MARSHALL",
    EstimatedCombinedRate: 0.0925,
  }],

  [73057,{
    ZipCode: 73057,
    TaxRegionName: "MAYSVILLE",
    EstimatedCombinedRate: 0.0925,
  }],

  [73058,{
    ZipCode: 73058,
    TaxRegionName: "MERIDIAN",
    EstimatedCombinedRate: 0.0725,
  }],

  [73059,{
    ZipCode: 73059,
    TaxRegionName: "MINCO",
    EstimatedCombinedRate: 0.0925,
  }],

  [73061,{
    ZipCode: 73061,
    TaxRegionName: "MORRISON",
    EstimatedCombinedRate: 0.1,
  }],

  [73062,{
    ZipCode: 73062,
    TaxRegionName: "MOUNTAIN VIEW",
    EstimatedCombinedRate: 0.09,
  }],

  [73063,{
    ZipCode: 73063,
    TaxRegionName: "MULHALL",
    EstimatedCombinedRate: 0.0825,
  }],

  [73064,{
    ZipCode: 73064,
    TaxRegionName: "OKLAHOMA CITY",
    EstimatedCombinedRate: 0.08975,
  }],

  [73065,{
    ZipCode: 73065,
    TaxRegionName: "TUTTLE",
    EstimatedCombinedRate: 0.0975,
  }],

  [73066,{
    ZipCode: 73066,
    TaxRegionName: "NICOMA PARK",
    EstimatedCombinedRate: 0.095,
  }],

  [73067,{
    ZipCode: 73067,
    TaxRegionName: "CHICKASHA",
    EstimatedCombinedRate: 0.09,
  }],

  [73068,{
    ZipCode: 73068,
    TaxRegionName: "NOBLE",
    EstimatedCombinedRate: 0.0875,
  }],

  [73069,{
    ZipCode: 73069,
    TaxRegionName: "NORMAN",
    EstimatedCombinedRate: 0.0875,
  }],

  [73070,{
    ZipCode: 73070,
    TaxRegionName: "NORMAN",
    EstimatedCombinedRate: 0.0875,
  }],

  [73071,{
    ZipCode: 73071,
    TaxRegionName: "NEWCASTLE",
    EstimatedCombinedRate: 0.09,
  }],

  [73072,{
    ZipCode: 73072,
    TaxRegionName: "NEWCASTLE",
    EstimatedCombinedRate: 0.09,
  }],

  [73073,{
    ZipCode: 73073,
    TaxRegionName: "ORLANDO",
    EstimatedCombinedRate: 0.09313,
  }],

  [73074,{
    ZipCode: 73074,
    TaxRegionName: "PAOLI",
    EstimatedCombinedRate: 0.0825,
  }],

  [73075,{
    ZipCode: 73075,
    TaxRegionName: "PAULS VALLEY",
    EstimatedCombinedRate: 0.0975,
  }],

  [73077,{
    ZipCode: 73077,
    TaxRegionName: "PERRY",
    EstimatedCombinedRate: 0.1025,
  }],

  [73078,{
    ZipCode: 73078,
    TaxRegionName: "PIEDMONT",
    EstimatedCombinedRate: 0.0985,
  }],

  [73079,{
    ZipCode: 73079,
    TaxRegionName: "POCASSET",
    EstimatedCombinedRate: 0.0675,
  }],

  [73080,{
    ZipCode: 73080,
    TaxRegionName: "PURCELL",
    EstimatedCombinedRate: 0.1,
  }],

  [73082,{
    ZipCode: 73082,
    TaxRegionName: "RUSH SPRINGS",
    EstimatedCombinedRate: 0.0975,
  }],

  [73083,{
    ZipCode: 73083,
    TaxRegionName: "EDMOND",
    EstimatedCombinedRate: 0.085,
  }],

  [73084,{
    ZipCode: 73084,
    TaxRegionName: "JONES",
    EstimatedCombinedRate: 0.095,
  }],

  [73085,{
    ZipCode: 73085,
    TaxRegionName: "YUKON",
    EstimatedCombinedRate: 0.0885,
  }],

  [73086,{
    ZipCode: 73086,
    TaxRegionName: "SULPHUR",
    EstimatedCombinedRate: 0.095,
  }],

  [73089,{
    ZipCode: 73089,
    TaxRegionName: "TUTTLE",
    EstimatedCombinedRate: 0.0975,
  }],

  [73090,{
    ZipCode: 73090,
    TaxRegionName: "UNION CITY",
    EstimatedCombinedRate: 0.0885,
  }],

  [73092,{
    ZipCode: 73092,
    TaxRegionName: "VERDEN",
    EstimatedCombinedRate: 0.09,
  }],

  [73093,{
    ZipCode: 73093,
    TaxRegionName: "PURCELL",
    EstimatedCombinedRate: 0.1,
  }],

  [73095,{
    ZipCode: 73095,
    TaxRegionName: "PURCELL",
    EstimatedCombinedRate: 0.1,
  }],

  [73096,{
    ZipCode: 73096,
    TaxRegionName: "WEATHERFORD",
    EstimatedCombinedRate: 0.095,
  }],

  [73097,{
    ZipCode: 73097,
    TaxRegionName: "OKLAHOMA CITY",
    EstimatedCombinedRate: 0.08625,
  }],

  [73098,{
    ZipCode: 73098,
    TaxRegionName: "WYNNEWOOD",
    EstimatedCombinedRate: 0.0925,
  }],

  [73099,{
    ZipCode: 73099,
    TaxRegionName: "PIEDMONT",
    EstimatedCombinedRate: 0.0985,
  }],

  [73101,{
    ZipCode: 73101,
    TaxRegionName: "OKLAHOMA CITY",
    EstimatedCombinedRate: 0.08625,
  }],

  [73102,{
    ZipCode: 73102,
    TaxRegionName: "OKLAHOMA CITY",
    EstimatedCombinedRate: 0.08625,
  }],

  [73103,{
    ZipCode: 73103,
    TaxRegionName: "OKLAHOMA CITY",
    EstimatedCombinedRate: 0.08625,
  }],

  [73104,{
    ZipCode: 73104,
    TaxRegionName: "OKLAHOMA CITY",
    EstimatedCombinedRate: 0.08625,
  }],

  [73105,{
    ZipCode: 73105,
    TaxRegionName: "OKLAHOMA CITY",
    EstimatedCombinedRate: 0.08625,
  }],

  [73106,{
    ZipCode: 73106,
    TaxRegionName: "OKLAHOMA CITY",
    EstimatedCombinedRate: 0.08625,
  }],

  [73107,{
    ZipCode: 73107,
    TaxRegionName: "OKLAHOMA CITY",
    EstimatedCombinedRate: 0.08625,
  }],

  [73108,{
    ZipCode: 73108,
    TaxRegionName: "OKLAHOMA CITY",
    EstimatedCombinedRate: 0.08625,
  }],

  [73109,{
    ZipCode: 73109,
    TaxRegionName: "OKLAHOMA CITY",
    EstimatedCombinedRate: 0.08625,
  }],

  [73110,{
    ZipCode: 73110,
    TaxRegionName: "MIDWEST CITY",
    EstimatedCombinedRate: 0.091,
  }],

  [73111,{
    ZipCode: 73111,
    TaxRegionName: "OKLAHOMA CITY",
    EstimatedCombinedRate: 0.08625,
  }],

  [73112,{
    ZipCode: 73112,
    TaxRegionName: "OKLAHOMA CITY",
    EstimatedCombinedRate: 0.08625,
  }],

  [73113,{
    ZipCode: 73113,
    TaxRegionName: "OKLAHOMA CITY",
    EstimatedCombinedRate: 0.08625,
  }],

  [73114,{
    ZipCode: 73114,
    TaxRegionName: "CLEVELAND",
    EstimatedCombinedRate: 0.0875,
  }],

  [73115,{
    ZipCode: 73115,
    TaxRegionName: "MIDWEST CITY",
    EstimatedCombinedRate: 0.091,
  }],

  [73116,{
    ZipCode: 73116,
    TaxRegionName: "OKLAHOMA CITY",
    EstimatedCombinedRate: 0.08625,
  }],

  [73117,{
    ZipCode: 73117,
    TaxRegionName: "MIDWEST CITY",
    EstimatedCombinedRate: 0.091,
  }],

  [73118,{
    ZipCode: 73118,
    TaxRegionName: "OKLAHOMA CITY",
    EstimatedCombinedRate: 0.08625,
  }],

  [73119,{
    ZipCode: 73119,
    TaxRegionName: "OKLAHOMA CITY",
    EstimatedCombinedRate: 0.08625,
  }],

  [73120,{
    ZipCode: 73120,
    TaxRegionName: "THE VILLAGE",
    EstimatedCombinedRate: 0.09,
  }],

  [73121,{
    ZipCode: 73121,
    TaxRegionName: "OKLAHOMA CITY",
    EstimatedCombinedRate: 0.08625,
  }],

  [73122,{
    ZipCode: 73122,
    TaxRegionName: "OKLAHOMA CITY",
    EstimatedCombinedRate: 0.08625,
  }],

  [73123,{
    ZipCode: 73123,
    TaxRegionName: "WARR ACRES",
    EstimatedCombinedRate: 0.085,
  }],

  [73124,{
    ZipCode: 73124,
    TaxRegionName: "OKLAHOMA CITY",
    EstimatedCombinedRate: 0.08625,
  }],

  [73125,{
    ZipCode: 73125,
    TaxRegionName: "OKLAHOMA CITY",
    EstimatedCombinedRate: 0.08625,
  }],

  [73126,{
    ZipCode: 73126,
    TaxRegionName: "OKLAHOMA CITY",
    EstimatedCombinedRate: 0.08625,
  }],

  [73127,{
    ZipCode: 73127,
    TaxRegionName: "OKLAHOMA CITY",
    EstimatedCombinedRate: 0.08975,
  }],

  [73128,{
    ZipCode: 73128,
    TaxRegionName: "OKLAHOMA CITY",
    EstimatedCombinedRate: 0.08975,
  }],

  [73129,{
    ZipCode: 73129,
    TaxRegionName: "DEL CITY",
    EstimatedCombinedRate: 0.09,
  }],

  [73130,{
    ZipCode: 73130,
    TaxRegionName: "NICOMA PARK",
    EstimatedCombinedRate: 0.095,
  }],

  [73131,{
    ZipCode: 73131,
    TaxRegionName: "OKLAHOMA CITY",
    EstimatedCombinedRate: 0.08625,
  }],

  [73132,{
    ZipCode: 73132,
    TaxRegionName: "OKLAHOMA CITY",
    EstimatedCombinedRate: 0.08975,
  }],

  [73134,{
    ZipCode: 73134,
    TaxRegionName: "THE VILLAGE",
    EstimatedCombinedRate: 0.09,
  }],

  [73135,{
    ZipCode: 73135,
    TaxRegionName: "DEL CITY",
    EstimatedCombinedRate: 0.09,
  }],

  [73136,{
    ZipCode: 73136,
    TaxRegionName: "OKLAHOMA CITY",
    EstimatedCombinedRate: 0.08625,
  }],

  [73137,{
    ZipCode: 73137,
    TaxRegionName: "OKLAHOMA CITY",
    EstimatedCombinedRate: 0.08625,
  }],

  [73139,{
    ZipCode: 73139,
    TaxRegionName: "CLEVELAND",
    EstimatedCombinedRate: 0.0875,
  }],

  [73140,{
    ZipCode: 73140,
    TaxRegionName: "MIDWEST CITY",
    EstimatedCombinedRate: 0.091,
  }],

  [73141,{
    ZipCode: 73141,
    TaxRegionName: "NICOMA PARK",
    EstimatedCombinedRate: 0.095,
  }],

  [73142,{
    ZipCode: 73142,
    TaxRegionName: "OKLAHOMA CITY",
    EstimatedCombinedRate: 0.08625,
  }],

  [73143,{
    ZipCode: 73143,
    TaxRegionName: "OKLAHOMA CITY",
    EstimatedCombinedRate: 0.08625,
  }],

  [73144,{
    ZipCode: 73144,
    TaxRegionName: "CLEVELAND",
    EstimatedCombinedRate: 0.0875,
  }],

  [73145,{
    ZipCode: 73145,
    TaxRegionName: "OKLAHOMA CITY",
    EstimatedCombinedRate: 0.08625,
  }],

  [73146,{
    ZipCode: 73146,
    TaxRegionName: "OKLAHOMA CITY",
    EstimatedCombinedRate: 0.08625,
  }],

  [73147,{
    ZipCode: 73147,
    TaxRegionName: "OKLAHOMA CITY",
    EstimatedCombinedRate: 0.08625,
  }],

  [73148,{
    ZipCode: 73148,
    TaxRegionName: "OKLAHOMA CITY",
    EstimatedCombinedRate: 0.08625,
  }],

  [73149,{
    ZipCode: 73149,
    TaxRegionName: "CLEVELAND",
    EstimatedCombinedRate: 0.0875,
  }],

  [73150,{
    ZipCode: 73150,
    TaxRegionName: "MIDWEST CITY",
    EstimatedCombinedRate: 0.091,
  }],

  [73151,{
    ZipCode: 73151,
    TaxRegionName: "OKLAHOMA CITY",
    EstimatedCombinedRate: 0.08625,
  }],

  [73152,{
    ZipCode: 73152,
    TaxRegionName: "OKLAHOMA CITY",
    EstimatedCombinedRate: 0.08625,
  }],

  [73153,{
    ZipCode: 73153,
    TaxRegionName: "MOORE",
    EstimatedCombinedRate: 0.085,
  }],

  [73154,{
    ZipCode: 73154,
    TaxRegionName: "OKLAHOMA CITY",
    EstimatedCombinedRate: 0.08625,
  }],

  [73155,{
    ZipCode: 73155,
    TaxRegionName: "DEL CITY",
    EstimatedCombinedRate: 0.09,
  }],

  [73156,{
    ZipCode: 73156,
    TaxRegionName: "THE VILLAGE",
    EstimatedCombinedRate: 0.09,
  }],

  [73157,{
    ZipCode: 73157,
    TaxRegionName: "OKLAHOMA CITY",
    EstimatedCombinedRate: 0.08625,
  }],

  [73159,{
    ZipCode: 73159,
    TaxRegionName: "CLEVELAND",
    EstimatedCombinedRate: 0.0875,
  }],

  [73160,{
    ZipCode: 73160,
    TaxRegionName: "CLEVELAND",
    EstimatedCombinedRate: 0.0875,
  }],

  [73162,{
    ZipCode: 73162,
    TaxRegionName: "OKLAHOMA CITY",
    EstimatedCombinedRate: 0.08975,
  }],

  [73163,{
    ZipCode: 73163,
    TaxRegionName: "OKLAHOMA CITY",
    EstimatedCombinedRate: 0.08625,
  }],

  [73164,{
    ZipCode: 73164,
    TaxRegionName: "OKLAHOMA CITY",
    EstimatedCombinedRate: 0.08625,
  }],

  [73165,{
    ZipCode: 73165,
    TaxRegionName: "DEL CITY",
    EstimatedCombinedRate: 0.09,
  }],

  [73167,{
    ZipCode: 73167,
    TaxRegionName: "OKLAHOMA CITY",
    EstimatedCombinedRate: 0.08625,
  }],

  [73169,{
    ZipCode: 73169,
    TaxRegionName: "CLEVELAND",
    EstimatedCombinedRate: 0.0875,
  }],

  [73170,{
    ZipCode: 73170,
    TaxRegionName: "CLEVELAND",
    EstimatedCombinedRate: 0.0875,
  }],

  [73172,{
    ZipCode: 73172,
    TaxRegionName: "OKLAHOMA CITY",
    EstimatedCombinedRate: 0.08625,
  }],

  [73173,{
    ZipCode: 73173,
    TaxRegionName: "OKLAHOMA CITY",
    EstimatedCombinedRate: 0.08975,
  }],

  [73178,{
    ZipCode: 73178,
    TaxRegionName: "OKLAHOMA CITY",
    EstimatedCombinedRate: 0.08625,
  }],

  [73179,{
    ZipCode: 73179,
    TaxRegionName: "OKLAHOMA CITY",
    EstimatedCombinedRate: 0.08975,
  }],

  [73184,{
    ZipCode: 73184,
    TaxRegionName: "OKLAHOMA CITY",
    EstimatedCombinedRate: 0.08625,
  }],

  [73189,{
    ZipCode: 73189,
    TaxRegionName: "CLEVELAND",
    EstimatedCombinedRate: 0.0875,
  }],

  [73190,{
    ZipCode: 73190,
    TaxRegionName: "OKLAHOMA CITY",
    EstimatedCombinedRate: 0.08625,
  }],

  [73194,{
    ZipCode: 73194,
    TaxRegionName: "OKLAHOMA CITY",
    EstimatedCombinedRate: 0.08625,
  }],

  [73195,{
    ZipCode: 73195,
    TaxRegionName: "OKLAHOMA CITY",
    EstimatedCombinedRate: 0.08625,
  }],

  [73196,{
    ZipCode: 73196,
    TaxRegionName: "OKLAHOMA CITY",
    EstimatedCombinedRate: 0.08625,
  }],

  [73401,{
    ZipCode: 73401,
    TaxRegionName: "MANNSVILLE",
    EstimatedCombinedRate: 0.095,
  }],

  [73402,{
    ZipCode: 73402,
    TaxRegionName: "ARDMORE",
    EstimatedCombinedRate: 0.09125,
  }],

  [73403,{
    ZipCode: 73403,
    TaxRegionName: "ARDMORE",
    EstimatedCombinedRate: 0.09125,
  }],

  [73425,{
    ZipCode: 73425,
    TaxRegionName: "STEPHENS",
    EstimatedCombinedRate: 0.052,
  }],

  [73430,{
    ZipCode: 73430,
    TaxRegionName: "LOVE",
    EstimatedCombinedRate: 0.07,
  }],

  [73432,{
    ZipCode: 73432,
    TaxRegionName: "JOHNSTON",
    EstimatedCombinedRate: 0.065,
  }],

  [73433,{
    ZipCode: 73433,
    TaxRegionName: "FOSTER",
    EstimatedCombinedRate: 0.0925,
  }],

  [73434,{
    ZipCode: 73434,
    TaxRegionName: "FOSTER",
    EstimatedCombinedRate: 0.0925,
  }],

  [73435,{
    ZipCode: 73435,
    TaxRegionName: "CARTER",
    EstimatedCombinedRate: 0.05375,
  }],

  [73436,{
    ZipCode: 73436,
    TaxRegionName: "GENE AUTRY",
    EstimatedCombinedRate: 0.08375,
  }],

  [73437,{
    ZipCode: 73437,
    TaxRegionName: "CARTER",
    EstimatedCombinedRate: 0.05375,
  }],

  [73438,{
    ZipCode: 73438,
    TaxRegionName: "HEALDTON",
    EstimatedCombinedRate: 0.09375,
  }],

  [73439,{
    ZipCode: 73439,
    TaxRegionName: "KINGSTON",
    EstimatedCombinedRate: 0.095,
  }],

  [73440,{
    ZipCode: 73440,
    TaxRegionName: "MARSHALL",
    EstimatedCombinedRate: 0.065,
  }],

  [73441,{
    ZipCode: 73441,
    TaxRegionName: "LEON",
    EstimatedCombinedRate: 0.07,
  }],

  [73442,{
    ZipCode: 73442,
    TaxRegionName: "LOCO",
    EstimatedCombinedRate: 0.082,
  }],

  [73443,{
    ZipCode: 73443,
    TaxRegionName: "LONE GROVE",
    EstimatedCombinedRate: 0.09375,
  }],

  [73444,{
    ZipCode: 73444,
    TaxRegionName: "MURRAY",
    EstimatedCombinedRate: 0.065,
  }],

  [73446,{
    ZipCode: 73446,
    TaxRegionName: "MADILL",
    EstimatedCombinedRate: 0.095,
  }],

  [73447,{
    ZipCode: 73447,
    TaxRegionName: "MANNSVILLE",
    EstimatedCombinedRate: 0.095,
  }],

  [73448,{
    ZipCode: 73448,
    TaxRegionName: "MARIETTA",
    EstimatedCombinedRate: 0.1,
  }],

  [73449,{
    ZipCode: 73449,
    TaxRegionName: "MEAD",
    EstimatedCombinedRate: 0.07,
  }],

  [73450,{
    ZipCode: 73450,
    TaxRegionName: "MILBURN",
    EstimatedCombinedRate: 0.085,
  }],

  [73453,{
    ZipCode: 73453,
    TaxRegionName: "LOVE",
    EstimatedCombinedRate: 0.07,
  }],

  [73455,{
    ZipCode: 73455,
    TaxRegionName: "RAVIA",
    EstimatedCombinedRate: 0.095,
  }],

  [73456,{
    ZipCode: 73456,
    TaxRegionName: "RINGLING",
    EstimatedCombinedRate: 0.09,
  }],

  [73458,{
    ZipCode: 73458,
    TaxRegionName: "ARDMORE",
    EstimatedCombinedRate: 0.09125,
  }],

  [73459,{
    ZipCode: 73459,
    TaxRegionName: "THACKERVILLE",
    EstimatedCombinedRate: 0.09,
  }],

  [73460,{
    ZipCode: 73460,
    TaxRegionName: "TISHOMINGO",
    EstimatedCombinedRate: 0.095,
  }],

  [73461,{
    ZipCode: 73461,
    TaxRegionName: "WAPANUCKA",
    EstimatedCombinedRate: 0.08,
  }],

  [73463,{
    ZipCode: 73463,
    TaxRegionName: "LONE GROVE",
    EstimatedCombinedRate: 0.09375,
  }],

  [73481,{
    ZipCode: 73481,
    TaxRegionName: "RATLIFF CITY",
    EstimatedCombinedRate: 0.08875,
  }],

  [73487,{
    ZipCode: 73487,
    TaxRegionName: "TATUMS",
    EstimatedCombinedRate: 0.10375,
  }],

  [73488,{
    ZipCode: 73488,
    TaxRegionName: "CARTER",
    EstimatedCombinedRate: 0.05375,
  }],

  [73491,{
    ZipCode: 73491,
    TaxRegionName: "VELMA",
    EstimatedCombinedRate: 0.092,
  }],

  [73501,{
    ZipCode: 73501,
    TaxRegionName: "LAWTON",
    EstimatedCombinedRate: 0.09,
  }],

  [73502,{
    ZipCode: 73502,
    TaxRegionName: "LAWTON",
    EstimatedCombinedRate: 0.09,
  }],

  [73503,{
    ZipCode: 73503,
    TaxRegionName: "LAWTON",
    EstimatedCombinedRate: 0.09,
  }],

  [73505,{
    ZipCode: 73505,
    TaxRegionName: "LAWTON",
    EstimatedCombinedRate: 0.09,
  }],

  [73506,{
    ZipCode: 73506,
    TaxRegionName: "LAWTON",
    EstimatedCombinedRate: 0.09,
  }],

  [73507,{
    ZipCode: 73507,
    TaxRegionName: "LAWTON",
    EstimatedCombinedRate: 0.09,
  }],

  [73520,{
    ZipCode: 73520,
    TaxRegionName: "ADDINGTON",
    EstimatedCombinedRate: 0.085,
  }],

  [73521,{
    ZipCode: 73521,
    TaxRegionName: "ALTUS",
    EstimatedCombinedRate: 0.0975,
  }],

  [73522,{
    ZipCode: 73522,
    TaxRegionName: "ALTUS",
    EstimatedCombinedRate: 0.0975,
  }],

  [73523,{
    ZipCode: 73523,
    TaxRegionName: "ALTUS",
    EstimatedCombinedRate: 0.0975,
  }],

  [73526,{
    ZipCode: 73526,
    TaxRegionName: "BLAIR",
    EstimatedCombinedRate: 0.08625,
  }],

  [73527,{
    ZipCode: 73527,
    TaxRegionName: "CACHE",
    EstimatedCombinedRate: 0.08625,
  }],

  [73528,{
    ZipCode: 73528,
    TaxRegionName: "CHATTANOOGA",
    EstimatedCombinedRate: 0.07875,
  }],

  [73529,{
    ZipCode: 73529,
    TaxRegionName: "COMANCHE",
    EstimatedCombinedRate: 0.092,
  }],

  [73530,{
    ZipCode: 73530,
    TaxRegionName: "DAVIDSON",
    EstimatedCombinedRate: 0.105,
  }],

  [73531,{
    ZipCode: 73531,
    TaxRegionName: "DEVOL",
    EstimatedCombinedRate: 0.065,
  }],

  [73532,{
    ZipCode: 73532,
    TaxRegionName: "DUKE",
    EstimatedCombinedRate: 0.09125,
  }],

  [73533,{
    ZipCode: 73533,
    TaxRegionName: "VELMA",
    EstimatedCombinedRate: 0.092,
  }],

  [73534,{
    ZipCode: 73534,
    TaxRegionName: "DUNCAN",
    EstimatedCombinedRate: 0.087,
  }],

  [73536,{
    ZipCode: 73536,
    TaxRegionName: "DUNCAN",
    EstimatedCombinedRate: 0.087,
  }],

  [73537,{
    ZipCode: 73537,
    TaxRegionName: "ELDORADO",
    EstimatedCombinedRate: 0.07625,
  }],

  [73538,{
    ZipCode: 73538,
    TaxRegionName: "ELGIN",
    EstimatedCombinedRate: 0.08875,
  }],

  [73539,{
    ZipCode: 73539,
    TaxRegionName: "ELMER",
    EstimatedCombinedRate: 0.05625,
  }],

  [73540,{
    ZipCode: 73540,
    TaxRegionName: "FAXON",
    EstimatedCombinedRate: 0.06875,
  }],

  [73541,{
    ZipCode: 73541,
    TaxRegionName: "ELGIN",
    EstimatedCombinedRate: 0.08875,
  }],

  [73542,{
    ZipCode: 73542,
    TaxRegionName: "FREDERICK",
    EstimatedCombinedRate: 0.1,
  }],

  [73543,{
    ZipCode: 73543,
    TaxRegionName: "GERONIMO",
    EstimatedCombinedRate: 0.07875,
  }],

  [73544,{
    ZipCode: 73544,
    TaxRegionName: "GOULD",
    EstimatedCombinedRate: 0.095,
  }],

  [73546,{
    ZipCode: 73546,
    TaxRegionName: "GRANDFIELD",
    EstimatedCombinedRate: 0.095,
  }],

  [73547,{
    ZipCode: 73547,
    TaxRegionName: "GRANITE",
    EstimatedCombinedRate: 0.095,
  }],

  [73548,{
    ZipCode: 73548,
    TaxRegionName: "HASTINGS",
    EstimatedCombinedRate: 0.095,
  }],

  [73549,{
    ZipCode: 73549,
    TaxRegionName: "HEADRICK",
    EstimatedCombinedRate: 0.05625,
  }],

  [73550,{
    ZipCode: 73550,
    TaxRegionName: "HOLLIS",
    EstimatedCombinedRate: 0.105,
  }],

  [73551,{
    ZipCode: 73551,
    TaxRegionName: "HOLLISTER",
    EstimatedCombinedRate: 0.095,
  }],

  [73552,{
    ZipCode: 73552,
    TaxRegionName: "INDIAHOMA",
    EstimatedCombinedRate: 0.08875,
  }],

  [73553,{
    ZipCode: 73553,
    TaxRegionName: "TILLMAN",
    EstimatedCombinedRate: 0.065,
  }],

  [73554,{
    ZipCode: 73554,
    TaxRegionName: "MANGUM",
    EstimatedCombinedRate: 0.095,
  }],

  [73555,{
    ZipCode: 73555,
    TaxRegionName: "MANITOU",
    EstimatedCombinedRate: 0.095,
  }],

  [73556,{
    ZipCode: 73556,
    TaxRegionName: "MARTHA",
    EstimatedCombinedRate: 0.05625,
  }],

  [73557,{
    ZipCode: 73557,
    TaxRegionName: "MEDICINE PARK",
    EstimatedCombinedRate: 0.09,
  }],

  [73558,{
    ZipCode: 73558,
    TaxRegionName: "COMANCHE",
    EstimatedCombinedRate: 0.04875,
  }],

  [73559,{
    ZipCode: 73559,
    TaxRegionName: "MOUNTAIN PARK",
    EstimatedCombinedRate: 0.08,
  }],

  [73560,{
    ZipCode: 73560,
    TaxRegionName: "OLUSTEE",
    EstimatedCombinedRate: 0.06625,
  }],

  [73561,{
    ZipCode: 73561,
    TaxRegionName: "JEFFERSON",
    EstimatedCombinedRate: 0.065,
  }],

  [73562,{
    ZipCode: 73562,
    TaxRegionName: "RANDLETT",
    EstimatedCombinedRate: 0.065,
  }],

  [73564,{
    ZipCode: 73564,
    TaxRegionName: "ROOSEVELT",
    EstimatedCombinedRate: 0.08,
  }],

  [73565,{
    ZipCode: 73565,
    TaxRegionName: "RYAN",
    EstimatedCombinedRate: 0.095,
  }],

  [73566,{
    ZipCode: 73566,
    TaxRegionName: "SNYDER",
    EstimatedCombinedRate: 0.09,
  }],

  [73567,{
    ZipCode: 73567,
    TaxRegionName: "STERLING",
    EstimatedCombinedRate: 0.07875,
  }],

  [73568,{
    ZipCode: 73568,
    TaxRegionName: "TEMPLE",
    EstimatedCombinedRate: 0.095,
  }],

  [73569,{
    ZipCode: 73569,
    TaxRegionName: "TERRAL",
    EstimatedCombinedRate: 0.095,
  }],

  [73570,{
    ZipCode: 73570,
    TaxRegionName: "TIPTON",
    EstimatedCombinedRate: 0.105,
  }],

  [73571,{
    ZipCode: 73571,
    TaxRegionName: "HARMON",
    EstimatedCombinedRate: 0.075,
  }],

  [73572,{
    ZipCode: 73572,
    TaxRegionName: "WALTERS",
    EstimatedCombinedRate: 0.095,
  }],

  [73573,{
    ZipCode: 73573,
    TaxRegionName: "WAURIKA",
    EstimatedCombinedRate: 0.095,
  }],

  [73601,{
    ZipCode: 73601,
    TaxRegionName: "CLINTON",
    EstimatedCombinedRate: 0.11,
  }],

  [73620,{
    ZipCode: 73620,
    TaxRegionName: "ARAPAHO",
    EstimatedCombinedRate: 0.08,
  }],

  [73622,{
    ZipCode: 73622,
    TaxRegionName: "BESSIE",
    EstimatedCombinedRate: 0.085,
  }],

  [73624,{
    ZipCode: 73624,
    TaxRegionName: "BURNS FLAT",
    EstimatedCombinedRate: 0.105,
  }],

  [73625,{
    ZipCode: 73625,
    TaxRegionName: "BUTLER",
    EstimatedCombinedRate: 0.08,
  }],

  [73626,{
    ZipCode: 73626,
    TaxRegionName: "CANUTE",
    EstimatedCombinedRate: 0.105,
  }],

  [73627,{
    ZipCode: 73627,
    TaxRegionName: "CARTER",
    EstimatedCombinedRate: 0.0885,
  }],

  [73628,{
    ZipCode: 73628,
    TaxRegionName: "CHEYENNE",
    EstimatedCombinedRate: 0.09,
  }],

  [73632,{
    ZipCode: 73632,
    TaxRegionName: "CORDELL",
    EstimatedCombinedRate: 0.105,
  }],

  [73638,{
    ZipCode: 73638,
    TaxRegionName: "ROGER MILLS",
    EstimatedCombinedRate: 0.06,
  }],

  [73639,{
    ZipCode: 73639,
    TaxRegionName: "CUSTER CITY",
    EstimatedCombinedRate: 0.09,
  }],

  [73641,{
    ZipCode: 73641,
    TaxRegionName: "DILL CITY",
    EstimatedCombinedRate: 0.095,
  }],

  [73642,{
    ZipCode: 73642,
    TaxRegionName: "ROGER MILLS",
    EstimatedCombinedRate: 0.06,
  }],

  [73644,{
    ZipCode: 73644,
    TaxRegionName: "ELK CITY",
    EstimatedCombinedRate: 0.0935,
  }],

  [73645,{
    ZipCode: 73645,
    TaxRegionName: "ERICK",
    EstimatedCombinedRate: 0.0985,
  }],

  [73646,{
    ZipCode: 73646,
    TaxRegionName: "DEWEY",
    EstimatedCombinedRate: 0.0625,
  }],

  [73647,{
    ZipCode: 73647,
    TaxRegionName: "BURNS FLAT",
    EstimatedCombinedRate: 0.105,
  }],

  [73648,{
    ZipCode: 73648,
    TaxRegionName: "ELK CITY",
    EstimatedCombinedRate: 0.0935,
  }],

  [73650,{
    ZipCode: 73650,
    TaxRegionName: "HAMMON",
    EstimatedCombinedRate: 0.09,
  }],

  [73651,{
    ZipCode: 73651,
    TaxRegionName: "HOBART",
    EstimatedCombinedRate: 0.09,
  }],

  [73654,{
    ZipCode: 73654,
    TaxRegionName: "LEEDEY",
    EstimatedCombinedRate: 0.0925,
  }],

  [73655,{
    ZipCode: 73655,
    TaxRegionName: "LONE WOLF",
    EstimatedCombinedRate: 0.08,
  }],

  [73658,{
    ZipCode: 73658,
    TaxRegionName: "OAKWOOD",
    EstimatedCombinedRate: 0.0625,
  }],

  [73659,{
    ZipCode: 73659,
    TaxRegionName: "DEWEY",
    EstimatedCombinedRate: 0.0625,
  }],

  [73660,{
    ZipCode: 73660,
    TaxRegionName: "REYDON",
    EstimatedCombinedRate: 0.08,
  }],

  [73661,{
    ZipCode: 73661,
    TaxRegionName: "ROCKY",
    EstimatedCombinedRate: 0.095,
  }],

  [73662,{
    ZipCode: 73662,
    TaxRegionName: "SAYRE",
    EstimatedCombinedRate: 0.0885,
  }],

  [73663,{
    ZipCode: 73663,
    TaxRegionName: "SEILING",
    EstimatedCombinedRate: 0.1025,
  }],

  [73664,{
    ZipCode: 73664,
    TaxRegionName: "SENTINEL",
    EstimatedCombinedRate: 0.095,
  }],

  [73666,{
    ZipCode: 73666,
    TaxRegionName: "SWEETWATER",
    EstimatedCombinedRate: 0.07,
  }],

  [73667,{
    ZipCode: 73667,
    TaxRegionName: "TALOGA",
    EstimatedCombinedRate: 0.0925,
  }],

  [73668,{
    ZipCode: 73668,
    TaxRegionName: "TEXOLA",
    EstimatedCombinedRate: 0.0585,
  }],

  [73669,{
    ZipCode: 73669,
    TaxRegionName: "THOMAS",
    EstimatedCombinedRate: 0.095,
  }],

  [73673,{
    ZipCode: 73673,
    TaxRegionName: "WILLOW",
    EstimatedCombinedRate: 0.085,
  }],

  [73701,{
    ZipCode: 73701,
    TaxRegionName: "ENID",
    EstimatedCombinedRate: 0.091,
  }],

  [73702,{
    ZipCode: 73702,
    TaxRegionName: "ENID",
    EstimatedCombinedRate: 0.091,
  }],

  [73703,{
    ZipCode: 73703,
    TaxRegionName: "ENID",
    EstimatedCombinedRate: 0.091,
  }],

  [73705,{
    ZipCode: 73705,
    TaxRegionName: "ENID",
    EstimatedCombinedRate: 0.091,
  }],

  [73706,{
    ZipCode: 73706,
    TaxRegionName: "ENID",
    EstimatedCombinedRate: 0.091,
  }],

  [73716,{
    ZipCode: 73716,
    TaxRegionName: "ALINE",
    EstimatedCombinedRate: 0.095,
  }],

  [73717,{
    ZipCode: 73717,
    TaxRegionName: "ALVA",
    EstimatedCombinedRate: 0.0925,
  }],

  [73718,{
    ZipCode: 73718,
    TaxRegionName: "AMES",
    EstimatedCombinedRate: 0.0925,
  }],

  [73719,{
    ZipCode: 73719,
    TaxRegionName: "AMORITA",
    EstimatedCombinedRate: 0.065,
  }],

  [73720,{
    ZipCode: 73720,
    TaxRegionName: "GARFIELD",
    EstimatedCombinedRate: 0.0485,
  }],

  [73722,{
    ZipCode: 73722,
    TaxRegionName: "BYRON",
    EstimatedCombinedRate: 0.085,
  }],

  [73724,{
    ZipCode: 73724,
    TaxRegionName: "CANTON",
    EstimatedCombinedRate: 0.08375,
  }],

  [73726,{
    ZipCode: 73726,
    TaxRegionName: "CARMEN",
    EstimatedCombinedRate: 0.095,
  }],

  [73727,{
    ZipCode: 73727,
    TaxRegionName: "CARRIER",
    EstimatedCombinedRate: 0.0485,
  }],

  [73728,{
    ZipCode: 73728,
    TaxRegionName: "CHEROKEE",
    EstimatedCombinedRate: 0.0975,
  }],

  [73729,{
    ZipCode: 73729,
    TaxRegionName: "CLEO SPRINGS",
    EstimatedCombinedRate: 0.0925,
  }],

  [73730,{
    ZipCode: 73730,
    TaxRegionName: "COVINGTON",
    EstimatedCombinedRate: 0.0885,
  }],

  [73731,{
    ZipCode: 73731,
    TaxRegionName: "DACOMA",
    EstimatedCombinedRate: 0.05,
  }],

  [73733,{
    ZipCode: 73733,
    TaxRegionName: "DOUGLAS",
    EstimatedCombinedRate: 0.0685,
  }],

  [73734,{
    ZipCode: 73734,
    TaxRegionName: "DOVER",
    EstimatedCombinedRate: 0.0975,
  }],

  [73735,{
    ZipCode: 73735,
    TaxRegionName: "DRUMMOND",
    EstimatedCombinedRate: 0.0785,
  }],

  [73736,{
    ZipCode: 73736,
    TaxRegionName: "FAIRMONT",
    EstimatedCombinedRate: 0.0785,
  }],

  [73737,{
    ZipCode: 73737,
    TaxRegionName: "FAIRVIEW",
    EstimatedCombinedRate: 0.1025,
  }],

  [73738,{
    ZipCode: 73738,
    TaxRegionName: "GARBER",
    EstimatedCombinedRate: 0.0885,
  }],

  [73739,{
    ZipCode: 73739,
    TaxRegionName: "GOLTRY",
    EstimatedCombinedRate: 0.095,
  }],

  [73741,{
    ZipCode: 73741,
    TaxRegionName: "HELENA",
    EstimatedCombinedRate: 0.095,
  }],

  [73742,{
    ZipCode: 73742,
    TaxRegionName: "HENNESSEY",
    EstimatedCombinedRate: 0.0975,
  }],

  [73743,{
    ZipCode: 73743,
    TaxRegionName: "HILLSDALE",
    EstimatedCombinedRate: 0.0585,
  }],

  [73744,{
    ZipCode: 73744,
    TaxRegionName: "HITCHCOCK",
    EstimatedCombinedRate: 0.08375,
  }],

  [73746,{
    ZipCode: 73746,
    TaxRegionName: "WOODS",
    EstimatedCombinedRate: 0.05,
  }],

  [73747,{
    ZipCode: 73747,
    TaxRegionName: "MAJOR",
    EstimatedCombinedRate: 0.0625,
  }],

  [73749,{
    ZipCode: 73749,
    TaxRegionName: "JET",
    EstimatedCombinedRate: 0.095,
  }],

  [73750,{
    ZipCode: 73750,
    TaxRegionName: "KINGFISHER",
    EstimatedCombinedRate: 0.0925,
  }],

  [73753,{
    ZipCode: 73753,
    TaxRegionName: "KREMLIN",
    EstimatedCombinedRate: 0.0785,
  }],

  [73754,{
    ZipCode: 73754,
    TaxRegionName: "LAHOMA",
    EstimatedCombinedRate: 0.0935,
  }],

  [73755,{
    ZipCode: 73755,
    TaxRegionName: "LONGDALE",
    EstimatedCombinedRate: 0.08375,
  }],

  [73756,{
    ZipCode: 73756,
    TaxRegionName: "LOYAL",
    EstimatedCombinedRate: 0.0975,
  }],

  [73757,{
    ZipCode: 73757,
    TaxRegionName: "NOBLE",
    EstimatedCombinedRate: 0.06,
  }],

  [73758,{
    ZipCode: 73758,
    TaxRegionName: "MANCHESTER",
    EstimatedCombinedRate: 0.0675,
  }],

  [73759,{
    ZipCode: 73759,
    TaxRegionName: "MEDFORD",
    EstimatedCombinedRate: 0.0975,
  }],

  [73760,{
    ZipCode: 73760,
    TaxRegionName: "MENO",
    EstimatedCombinedRate: 0.0925,
  }],

  [73761,{
    ZipCode: 73761,
    TaxRegionName: "NASH",
    EstimatedCombinedRate: 0.0875,
  }],

  [73762,{
    ZipCode: 73762,
    TaxRegionName: "PIEDMONT",
    EstimatedCombinedRate: 0.1075,
  }],

  [73763,{
    ZipCode: 73763,
    TaxRegionName: "OKEENE",
    EstimatedCombinedRate: 0.09625,
  }],

  [73764,{
    ZipCode: 73764,
    TaxRegionName: "KINGFISHER",
    EstimatedCombinedRate: 0.0575,
  }],

  [73766,{
    ZipCode: 73766,
    TaxRegionName: "POND CREEK",
    EstimatedCombinedRate: 0.0975,
  }],

  [73768,{
    ZipCode: 73768,
    TaxRegionName: "MENO",
    EstimatedCombinedRate: 0.0925,
  }],

  [73770,{
    ZipCode: 73770,
    TaxRegionName: "BLAINE",
    EstimatedCombinedRate: 0.05375,
  }],

  [73771,{
    ZipCode: 73771,
    TaxRegionName: "WAKITA",
    EstimatedCombinedRate: 0.0975,
  }],

  [73772,{
    ZipCode: 73772,
    TaxRegionName: "WATONGA",
    EstimatedCombinedRate: 0.10375,
  }],

  [73773,{
    ZipCode: 73773,
    TaxRegionName: "WAUKOMIS",
    EstimatedCombinedRate: 0.0885,
  }],

  [73801,{
    ZipCode: 73801,
    TaxRegionName: "WOODWARD",
    EstimatedCombinedRate: 0.094,
  }],

  [73802,{
    ZipCode: 73802,
    TaxRegionName: "WOODWARD",
    EstimatedCombinedRate: 0.094,
  }],

  [73832,{
    ZipCode: 73832,
    TaxRegionName: "ARNETT",
    EstimatedCombinedRate: 0.095,
  }],

  [73834,{
    ZipCode: 73834,
    TaxRegionName: "BUFFALO",
    EstimatedCombinedRate: 0.095,
  }],

  [73835,{
    ZipCode: 73835,
    TaxRegionName: "CAMARGO",
    EstimatedCombinedRate: 0.1025,
  }],

  [73838,{
    ZipCode: 73838,
    TaxRegionName: "MAJOR",
    EstimatedCombinedRate: 0.0625,
  }],

  [73840,{
    ZipCode: 73840,
    TaxRegionName: "FARGO",
    EstimatedCombinedRate: 0.095,
  }],

  [73841,{
    ZipCode: 73841,
    TaxRegionName: "FORT SUPPLY",
    EstimatedCombinedRate: 0.084,
  }],

  [73842,{
    ZipCode: 73842,
    TaxRegionName: "FREEDOM",
    EstimatedCombinedRate: 0.07,
  }],

  [73843,{
    ZipCode: 73843,
    TaxRegionName: "GAGE",
    EstimatedCombinedRate: 0.095,
  }],

  [73844,{
    ZipCode: 73844,
    TaxRegionName: "GATE",
    EstimatedCombinedRate: 0.085,
  }],

  [73848,{
    ZipCode: 73848,
    TaxRegionName: "LAVERNE",
    EstimatedCombinedRate: 0.0975,
  }],

  [73851,{
    ZipCode: 73851,
    TaxRegionName: "MAY",
    EstimatedCombinedRate: 0.085,
  }],

  [73852,{
    ZipCode: 73852,
    TaxRegionName: "MOORELAND",
    EstimatedCombinedRate: 0.094,
  }],

  [73853,{
    ZipCode: 73853,
    TaxRegionName: "MUTUAL",
    EstimatedCombinedRate: 0.054,
  }],

  [73855,{
    ZipCode: 73855,
    TaxRegionName: "HARPER",
    EstimatedCombinedRate: 0.065,
  }],

  [73857,{
    ZipCode: 73857,
    TaxRegionName: "SHARON",
    EstimatedCombinedRate: 0.054,
  }],

  [73858,{
    ZipCode: 73858,
    TaxRegionName: "SHATTUCK",
    EstimatedCombinedRate: 0.105,
  }],

  [73859,{
    ZipCode: 73859,
    TaxRegionName: "VICI",
    EstimatedCombinedRate: 0.1025,
  }],

  [73860,{
    ZipCode: 73860,
    TaxRegionName: "WAYNOKA",
    EstimatedCombinedRate: 0.09,
  }],

  [73901,{
    ZipCode: 73901,
    TaxRegionName: "TEXAS",
    EstimatedCombinedRate: 0.0595,
  }],

  [73931,{
    ZipCode: 73931,
    TaxRegionName: "BEAVER",
    EstimatedCombinedRate: 0.065,
  }],

  [73932,{
    ZipCode: 73932,
    TaxRegionName: "BEAVER",
    EstimatedCombinedRate: 0.095,
  }],

  [73933,{
    ZipCode: 73933,
    TaxRegionName: "BOISE CITY",
    EstimatedCombinedRate: 0.095,
  }],

  [73937,{
    ZipCode: 73937,
    TaxRegionName: "CIMARRON",
    EstimatedCombinedRate: 0.065,
  }],

  [73938,{
    ZipCode: 73938,
    TaxRegionName: "FORGAN",
    EstimatedCombinedRate: 0.095,
  }],

  [73939,{
    ZipCode: 73939,
    TaxRegionName: "GOODWELL",
    EstimatedCombinedRate: 0.0895,
  }],

  [73942,{
    ZipCode: 73942,
    TaxRegionName: "GUYMON",
    EstimatedCombinedRate: 0.0995,
  }],

  [73944,{
    ZipCode: 73944,
    TaxRegionName: "HARDESTY",
    EstimatedCombinedRate: 0.0995,
  }],

  [73945,{
    ZipCode: 73945,
    TaxRegionName: "HOOKER",
    EstimatedCombinedRate: 0.0995,
  }],

  [73946,{
    ZipCode: 73946,
    TaxRegionName: "CIMARRON",
    EstimatedCombinedRate: 0.065,
  }],

  [73947,{
    ZipCode: 73947,
    TaxRegionName: "KEYES",
    EstimatedCombinedRate: 0.085,
  }],

  [73949,{
    ZipCode: 73949,
    TaxRegionName: "TEXHOMA",
    EstimatedCombinedRate: 0.0895,
  }],

  [73950,{
    ZipCode: 73950,
    TaxRegionName: "BEAVER",
    EstimatedCombinedRate: 0.065,
  }],

  [73951,{
    ZipCode: 73951,
    TaxRegionName: "TYRONE",
    EstimatedCombinedRate: 0.0895,
  }],

  [74001,{
    ZipCode: 74001,
    TaxRegionName: "AVANT",
    EstimatedCombinedRate: 0.0775,
  }],

  [74002,{
    ZipCode: 74002,
    TaxRegionName: "BARNSDALL",
    EstimatedCombinedRate: 0.0975,
  }],

  [74003,{
    ZipCode: 74003,
    TaxRegionName: "BARTLESVILLE",
    EstimatedCombinedRate: 0.0915,
  }],

  [74004,{
    ZipCode: 74004,
    TaxRegionName: "BARTLESVILLE",
    EstimatedCombinedRate: 0.089,
  }],

  [74005,{
    ZipCode: 74005,
    TaxRegionName: "BARTLESVILLE",
    EstimatedCombinedRate: 0.089,
  }],

  [74006,{
    ZipCode: 74006,
    TaxRegionName: "BARTLESVILLE",
    EstimatedCombinedRate: 0.089,
  }],

  [74008,{
    ZipCode: 74008,
    TaxRegionName: "GLENPOOL",
    EstimatedCombinedRate: 0.09967,
  }],

  [74010,{
    ZipCode: 74010,
    TaxRegionName: "BRISTOW",
    EstimatedCombinedRate: 0.10667,
  }],

  [74011,{
    ZipCode: 74011,
    TaxRegionName: "BIXBY",
    EstimatedCombinedRate: 0.08917,
  }],

  [74012,{
    ZipCode: 74012,
    TaxRegionName: "BROKEN ARROW",
    EstimatedCombinedRate: 0.0935,
  }],

  [74013,{
    ZipCode: 74013,
    TaxRegionName: "BROKEN ARROW",
    EstimatedCombinedRate: 0.08417,
  }],

  [74014,{
    ZipCode: 74014,
    TaxRegionName: "TULSA",
    EstimatedCombinedRate: 0.0945,
  }],

  [74015,{
    ZipCode: 74015,
    TaxRegionName: "OWASSO",
    EstimatedCombinedRate: 0.10383,
  }],

  [74016,{
    ZipCode: 74016,
    TaxRegionName: "CHELSEA",
    EstimatedCombinedRate: 0.09333,
  }],

  [74017,{
    ZipCode: 74017,
    TaxRegionName: "FOYIL",
    EstimatedCombinedRate: 0.10333,
  }],

  [74018,{
    ZipCode: 74018,
    TaxRegionName: "CLAREMORE",
    EstimatedCombinedRate: 0.09333,
  }],

  [74019,{
    ZipCode: 74019,
    TaxRegionName: "OWASSO",
    EstimatedCombinedRate: 0.10383,
  }],

  [74020,{
    ZipCode: 74020,
    TaxRegionName: "CLEVELAND",
    EstimatedCombinedRate: 0.0925,
  }],

  [74021,{
    ZipCode: 74021,
    TaxRegionName: "COLLINSVILLE",
    EstimatedCombinedRate: 0.10633,
  }],

  [74022,{
    ZipCode: 74022,
    TaxRegionName: "COPAN",
    EstimatedCombinedRate: 0.085,
  }],

  [74023,{
    ZipCode: 74023,
    TaxRegionName: "CUSHING",
    EstimatedCombinedRate: 0.09313,
  }],

  [74026,{
    ZipCode: 74026,
    TaxRegionName: "DAVENPORT",
    EstimatedCombinedRate: 0.095,
  }],

  [74027,{
    ZipCode: 74027,
    TaxRegionName: "DELAWARE",
    EstimatedCombinedRate: 0.085,
  }],

  [74028,{
    ZipCode: 74028,
    TaxRegionName: "DEPEW",
    EstimatedCombinedRate: 0.09667,
  }],

  [74029,{
    ZipCode: 74029,
    TaxRegionName: "DEWEY",
    EstimatedCombinedRate: 0.089,
  }],

  [74030,{
    ZipCode: 74030,
    TaxRegionName: "OILTON",
    EstimatedCombinedRate: 0.10667,
  }],

  [74031,{
    ZipCode: 74031,
    TaxRegionName: "FOYIL",
    EstimatedCombinedRate: 0.10333,
  }],

  [74032,{
    ZipCode: 74032,
    TaxRegionName: "GLENCOE",
    EstimatedCombinedRate: 0.09975,
  }],

  [74033,{
    ZipCode: 74033,
    TaxRegionName: "GLENPOOL",
    EstimatedCombinedRate: 0.09967,
  }],

  [74034,{
    ZipCode: 74034,
    TaxRegionName: "HALLETT",
    EstimatedCombinedRate: 0.1025,
  }],

  [74035,{
    ZipCode: 74035,
    TaxRegionName: "HOMINY",
    EstimatedCombinedRate: 0.0925,
  }],

  [74036,{
    ZipCode: 74036,
    TaxRegionName: "CLAREMORE",
    EstimatedCombinedRate: 0.09333,
  }],

  [74037,{
    ZipCode: 74037,
    TaxRegionName: "GLENPOOL",
    EstimatedCombinedRate: 0.09967,
  }],

  [74038,{
    ZipCode: 74038,
    TaxRegionName: "HALLETT",
    EstimatedCombinedRate: 0.1025,
  }],

  [74039,{
    ZipCode: 74039,
    TaxRegionName: "SAPULPA",
    EstimatedCombinedRate: 0.09667,
  }],

  [74041,{
    ZipCode: 74041,
    TaxRegionName: "KIEFER",
    EstimatedCombinedRate: 0.09667,
  }],

  [74042,{
    ZipCode: 74042,
    TaxRegionName: "LENAPAH",
    EstimatedCombinedRate: 0.085,
  }],

  [74043,{
    ZipCode: 74043,
    TaxRegionName: "TULSA",
    EstimatedCombinedRate: 0.04867,
  }],

  [74044,{
    ZipCode: 74044,
    TaxRegionName: "MANNFORD",
    EstimatedCombinedRate: 0.0925,
  }],

  [74045,{
    ZipCode: 74045,
    TaxRegionName: "MARAMEC",
    EstimatedCombinedRate: 0.0875,
  }],

  [74046,{
    ZipCode: 74046,
    TaxRegionName: "CREEK",
    EstimatedCombinedRate: 0.05667,
  }],

  [74047,{
    ZipCode: 74047,
    TaxRegionName: "BEGGS",
    EstimatedCombinedRate: 0.10583,
  }],

  [74048,{
    ZipCode: 74048,
    TaxRegionName: "NOWATA",
    EstimatedCombinedRate: 0.095,
  }],

  [74050,{
    ZipCode: 74050,
    TaxRegionName: "SAPULPA",
    EstimatedCombinedRate: 0.09667,
  }],

  [74051,{
    ZipCode: 74051,
    TaxRegionName: "BARTLESVILLE",
    EstimatedCombinedRate: 0.089,
  }],

  [74052,{
    ZipCode: 74052,
    TaxRegionName: "OILTON",
    EstimatedCombinedRate: 0.10667,
  }],

  [74053,{
    ZipCode: 74053,
    TaxRegionName: "OOLOGAH",
    EstimatedCombinedRate: 0.09333,
  }],

  [74054,{
    ZipCode: 74054,
    TaxRegionName: "OSAGE",
    EstimatedCombinedRate: 0.0575,
  }],

  [74055,{
    ZipCode: 74055,
    TaxRegionName: "OWASSO",
    EstimatedCombinedRate: 0.10383,
  }],

  [74056,{
    ZipCode: 74056,
    TaxRegionName: "PAWHUSKA",
    EstimatedCombinedRate: 0.0975,
  }],

  [74058,{
    ZipCode: 74058,
    TaxRegionName: "PAWNEE",
    EstimatedCombinedRate: 0.0925,
  }],

  [74059,{
    ZipCode: 74059,
    TaxRegionName: "PERKINS",
    EstimatedCombinedRate: 0.08688,
  }],

  [74060,{
    ZipCode: 74060,
    TaxRegionName: "PRUE",
    EstimatedCombinedRate: 0.0875,
  }],

  [74061,{
    ZipCode: 74061,
    TaxRegionName: "RAMONA",
    EstimatedCombinedRate: 0.075,
  }],

  [74062,{
    ZipCode: 74062,
    TaxRegionName: "RIPLEY",
    EstimatedCombinedRate: 0.08313,
  }],

  [74063,{
    ZipCode: 74063,
    TaxRegionName: "SAND SPRINGS",
    EstimatedCombinedRate: 0.098,
  }],

  [74066,{
    ZipCode: 74066,
    TaxRegionName: "GLENPOOL",
    EstimatedCombinedRate: 0.09967,
  }],

  [74067,{
    ZipCode: 74067,
    TaxRegionName: "SAPULPA",
    EstimatedCombinedRate: 0.09667,
  }],

  [74068,{
    ZipCode: 74068,
    TaxRegionName: "SHAMROCK",
    EstimatedCombinedRate: 0.08667,
  }],

  [74070,{
    ZipCode: 74070,
    TaxRegionName: "SAND SPRINGS",
    EstimatedCombinedRate: 0.098,
  }],

  [74071,{
    ZipCode: 74071,
    TaxRegionName: "SLICK",
    EstimatedCombinedRate: 0.08667,
  }],

  [74072,{
    ZipCode: 74072,
    TaxRegionName: "SOUTH COFFEYVILLE",
    EstimatedCombinedRate: 0.085,
  }],

  [74073,{
    ZipCode: 74073,
    TaxRegionName: "SAND SPRINGS",
    EstimatedCombinedRate: 0.098,
  }],

  [74074,{
    ZipCode: 74074,
    TaxRegionName: "STILLWATER",
    EstimatedCombinedRate: 0.08813,
  }],

  [74075,{
    ZipCode: 74075,
    TaxRegionName: "STILLWATER",
    EstimatedCombinedRate: 0.08813,
  }],

  [74076,{
    ZipCode: 74076,
    TaxRegionName: "STILLWATER",
    EstimatedCombinedRate: 0.08813,
  }],

  [74077,{
    ZipCode: 74077,
    TaxRegionName: "STILLWATER",
    EstimatedCombinedRate: 0.08813,
  }],

  [74078,{
    ZipCode: 74078,
    TaxRegionName: "STILLWATER",
    EstimatedCombinedRate: 0.08813,
  }],

  [74079,{
    ZipCode: 74079,
    TaxRegionName: "KENDRICK",
    EstimatedCombinedRate: 0.095,
  }],

  [74080,{
    ZipCode: 74080,
    TaxRegionName: "TALALA",
    EstimatedCombinedRate: 0.09333,
  }],

  [74081,{
    ZipCode: 74081,
    TaxRegionName: "MANNFORD",
    EstimatedCombinedRate: 0.0925,
  }],

  [74082,{
    ZipCode: 74082,
    TaxRegionName: "VERA",
    EstimatedCombinedRate: 0.075,
  }],

  [74083,{
    ZipCode: 74083,
    TaxRegionName: "WANN",
    EstimatedCombinedRate: 0.085,
  }],

  [74084,{
    ZipCode: 74084,
    TaxRegionName: "WYNONA",
    EstimatedCombinedRate: 0.0975,
  }],

  [74085,{
    ZipCode: 74085,
    TaxRegionName: "YALE",
    EstimatedCombinedRate: 0.09313,
  }],

  [74101,{
    ZipCode: 74101,
    TaxRegionName: "TULSA",
    EstimatedCombinedRate: 0.08517,
  }],

  [74102,{
    ZipCode: 74102,
    TaxRegionName: "TULSA",
    EstimatedCombinedRate: 0.08517,
  }],

  [74103,{
    ZipCode: 74103,
    TaxRegionName: "TULSA",
    EstimatedCombinedRate: 0.094,
  }],

  [74104,{
    ZipCode: 74104,
    TaxRegionName: "TULSA",
    EstimatedCombinedRate: 0.08517,
  }],

  [74105,{
    ZipCode: 74105,
    TaxRegionName: "TULSA",
    EstimatedCombinedRate: 0.08517,
  }],

  [74106,{
    ZipCode: 74106,
    TaxRegionName: "TULSA",
    EstimatedCombinedRate: 0.094,
  }],

  [74107,{
    ZipCode: 74107,
    TaxRegionName: "SAPULPA",
    EstimatedCombinedRate: 0.09667,
  }],

  [74108,{
    ZipCode: 74108,
    TaxRegionName: "TULSA",
    EstimatedCombinedRate: 0.0945,
  }],

  [74110,{
    ZipCode: 74110,
    TaxRegionName: "TULSA",
    EstimatedCombinedRate: 0.08517,
  }],

  [74112,{
    ZipCode: 74112,
    TaxRegionName: "TULSA",
    EstimatedCombinedRate: 0.08517,
  }],

  [74114,{
    ZipCode: 74114,
    TaxRegionName: "TULSA",
    EstimatedCombinedRate: 0.08517,
  }],

  [74115,{
    ZipCode: 74115,
    TaxRegionName: "TULSA",
    EstimatedCombinedRate: 0.08517,
  }],

  [74116,{
    ZipCode: 74116,
    TaxRegionName: "CATOOSA",
    EstimatedCombinedRate: 0.09583,
  }],

  [74117,{
    ZipCode: 74117,
    TaxRegionName: "TULSA",
    EstimatedCombinedRate: 0.08517,
  }],

  [74119,{
    ZipCode: 74119,
    TaxRegionName: "TULSA",
    EstimatedCombinedRate: 0.08517,
  }],

  [74120,{
    ZipCode: 74120,
    TaxRegionName: "TULSA",
    EstimatedCombinedRate: 0.08517,
  }],

  [74121,{
    ZipCode: 74121,
    TaxRegionName: "TULSA",
    EstimatedCombinedRate: 0.08517,
  }],

  [74126,{
    ZipCode: 74126,
    TaxRegionName: "SAND SPRINGS",
    EstimatedCombinedRate: 0.098,
  }],

  [74127,{
    ZipCode: 74127,
    TaxRegionName: "SAND SPRINGS",
    EstimatedCombinedRate: 0.098,
  }],

  [74128,{
    ZipCode: 74128,
    TaxRegionName: "TULSA",
    EstimatedCombinedRate: 0.08517,
  }],

  [74129,{
    ZipCode: 74129,
    TaxRegionName: "TULSA",
    EstimatedCombinedRate: 0.08517,
  }],

  [74130,{
    ZipCode: 74130,
    TaxRegionName: "TULSA",
    EstimatedCombinedRate: 0.08517,
  }],

  [74131,{
    ZipCode: 74131,
    TaxRegionName: "SAPULPA",
    EstimatedCombinedRate: 0.09667,
  }],

  [74132,{
    ZipCode: 74132,
    TaxRegionName: "SAPULPA",
    EstimatedCombinedRate: 0.09667,
  }],

  [74133,{
    ZipCode: 74133,
    TaxRegionName: "BIXBY",
    EstimatedCombinedRate: 0.08917,
  }],

  [74134,{
    ZipCode: 74134,
    TaxRegionName: "TULSA",
    EstimatedCombinedRate: 0.08517,
  }],

  [74135,{
    ZipCode: 74135,
    TaxRegionName: "TULSA",
    EstimatedCombinedRate: 0.08517,
  }],

  [74136,{
    ZipCode: 74136,
    TaxRegionName: "TULSA",
    EstimatedCombinedRate: 0.08517,
  }],

  [74137,{
    ZipCode: 74137,
    TaxRegionName: "TULSA",
    EstimatedCombinedRate: 0.08517,
  }],

  [74141,{
    ZipCode: 74141,
    TaxRegionName: "TULSA",
    EstimatedCombinedRate: 0.08517,
  }],

  [74145,{
    ZipCode: 74145,
    TaxRegionName: "TULSA",
    EstimatedCombinedRate: 0.08517,
  }],

  [74146,{
    ZipCode: 74146,
    TaxRegionName: "TULSA",
    EstimatedCombinedRate: 0.08517,
  }],

  [74147,{
    ZipCode: 74147,
    TaxRegionName: "TULSA",
    EstimatedCombinedRate: 0.08517,
  }],

  [74148,{
    ZipCode: 74148,
    TaxRegionName: "TULSA",
    EstimatedCombinedRate: 0.08517,
  }],

  [74149,{
    ZipCode: 74149,
    TaxRegionName: "TULSA",
    EstimatedCombinedRate: 0.08517,
  }],

  [74150,{
    ZipCode: 74150,
    TaxRegionName: "TULSA",
    EstimatedCombinedRate: 0.08517,
  }],

  [74152,{
    ZipCode: 74152,
    TaxRegionName: "TULSA",
    EstimatedCombinedRate: 0.08517,
  }],

  [74153,{
    ZipCode: 74153,
    TaxRegionName: "TULSA",
    EstimatedCombinedRate: 0.08517,
  }],

  [74155,{
    ZipCode: 74155,
    TaxRegionName: "TULSA",
    EstimatedCombinedRate: 0.08517,
  }],

  [74156,{
    ZipCode: 74156,
    TaxRegionName: "TULSA",
    EstimatedCombinedRate: 0.08517,
  }],

  [74157,{
    ZipCode: 74157,
    TaxRegionName: "TULSA",
    EstimatedCombinedRate: 0.08517,
  }],

  [74158,{
    ZipCode: 74158,
    TaxRegionName: "TULSA",
    EstimatedCombinedRate: 0.08517,
  }],

  [74159,{
    ZipCode: 74159,
    TaxRegionName: "TULSA",
    EstimatedCombinedRate: 0.08517,
  }],

  [74169,{
    ZipCode: 74169,
    TaxRegionName: "TULSA",
    EstimatedCombinedRate: 0.08517,
  }],

  [74170,{
    ZipCode: 74170,
    TaxRegionName: "TULSA",
    EstimatedCombinedRate: 0.08517,
  }],

  [74171,{
    ZipCode: 74171,
    TaxRegionName: "TULSA",
    EstimatedCombinedRate: 0.08517,
  }],

  [74172,{
    ZipCode: 74172,
    TaxRegionName: "TULSA",
    EstimatedCombinedRate: 0.08517,
  }],

  [74182,{
    ZipCode: 74182,
    TaxRegionName: "TULSA",
    EstimatedCombinedRate: 0.08517,
  }],

  [74186,{
    ZipCode: 74186,
    TaxRegionName: "TULSA",
    EstimatedCombinedRate: 0.08517,
  }],

  [74187,{
    ZipCode: 74187,
    TaxRegionName: "TULSA",
    EstimatedCombinedRate: 0.08517,
  }],

  [74192,{
    ZipCode: 74192,
    TaxRegionName: "TULSA",
    EstimatedCombinedRate: 0.08517,
  }],

  [74193,{
    ZipCode: 74193,
    TaxRegionName: "TULSA",
    EstimatedCombinedRate: 0.08517,
  }],

  [74301,{
    ZipCode: 74301,
    TaxRegionName: "KETCHUM",
    EstimatedCombinedRate: 0.095,
  }],

  [74330,{
    ZipCode: 74330,
    TaxRegionName: "ADAIR",
    EstimatedCombinedRate: 0.09875,
  }],

  [74331,{
    ZipCode: 74331,
    TaxRegionName: "KETCHUM",
    EstimatedCombinedRate: 0.095,
  }],

  [74332,{
    ZipCode: 74332,
    TaxRegionName: "BIG CABIN",
    EstimatedCombinedRate: 0.09,
  }],

  [74333,{
    ZipCode: 74333,
    TaxRegionName: "BLUEJACKET",
    EstimatedCombinedRate: 0.085,
  }],

  [74335,{
    ZipCode: 74335,
    TaxRegionName: "OTTAWA",
    EstimatedCombinedRate: 0.0585,
  }],

  [74337,{
    ZipCode: 74337,
    TaxRegionName: "CHOUTEAU",
    EstimatedCombinedRate: 0.10375,
  }],

  [74338,{
    ZipCode: 74338,
    TaxRegionName: "WEST SILOAM SPRINGS",
    EstimatedCombinedRate: 0.1065,
  }],

  [74339,{
    ZipCode: 74339,
    TaxRegionName: "NORTH MIAMI",
    EstimatedCombinedRate: 0.0935,
  }],

  [74340,{
    ZipCode: 74340,
    TaxRegionName: "DISNEY",
    EstimatedCombinedRate: 0.0975,
  }],

  [74342,{
    ZipCode: 74342,
    TaxRegionName: "DELAWARE",
    EstimatedCombinedRate: 0.059,
  }],

  [74343,{
    ZipCode: 74343,
    TaxRegionName: "FAIRLAND",
    EstimatedCombinedRate: 0.0885,
  }],

  [74344,{
    ZipCode: 74344,
    TaxRegionName: "GROVE",
    EstimatedCombinedRate: 0.093,
  }],

  [74345,{
    ZipCode: 74345,
    TaxRegionName: "GROVE",
    EstimatedCombinedRate: 0.093,
  }],

  [74346,{
    ZipCode: 74346,
    TaxRegionName: "JAY",
    EstimatedCombinedRate: 0.089,
  }],

  [74347,{
    ZipCode: 74347,
    TaxRegionName: "KANSAS",
    EstimatedCombinedRate: 0.099,
  }],

  [74349,{
    ZipCode: 74349,
    TaxRegionName: "KETCHUM",
    EstimatedCombinedRate: 0.095,
  }],

  [74350,{
    ZipCode: 74350,
    TaxRegionName: "LANGLEY",
    EstimatedCombinedRate: 0.08875,
  }],

  [74352,{
    ZipCode: 74352,
    TaxRegionName: "LOCUST GROVE",
    EstimatedCombinedRate: 0.10875,
  }],

  [74354,{
    ZipCode: 74354,
    TaxRegionName: "MIAMI",
    EstimatedCombinedRate: 0.095,
  }],

  [74355,{
    ZipCode: 74355,
    TaxRegionName: "MIAMI",
    EstimatedCombinedRate: 0.095,
  }],

  [74358,{
    ZipCode: 74358,
    TaxRegionName: "NORTH MIAMI",
    EstimatedCombinedRate: 0.0935,
  }],

  [74359,{
    ZipCode: 74359,
    TaxRegionName: "OAKS",
    EstimatedCombinedRate: 0.089,
  }],

  [74360,{
    ZipCode: 74360,
    TaxRegionName: "OTTAWA",
    EstimatedCombinedRate: 0.0585,
  }],

  [74361,{
    ZipCode: 74361,
    TaxRegionName: "PRYOR",
    EstimatedCombinedRate: 0.09875,
  }],

  [74362,{
    ZipCode: 74362,
    TaxRegionName: "PRYOR",
    EstimatedCombinedRate: 0.09875,
  }],

  [74363,{
    ZipCode: 74363,
    TaxRegionName: "QUAPAW",
    EstimatedCombinedRate: 0.0885,
  }],

  [74364,{
    ZipCode: 74364,
    TaxRegionName: "CHEROKEE",
    EstimatedCombinedRate: 0.0625,
  }],

  [74365,{
    ZipCode: 74365,
    TaxRegionName: "SALINA",
    EstimatedCombinedRate: 0.09875,
  }],

  [74366,{
    ZipCode: 74366,
    TaxRegionName: "SPAVINAW",
    EstimatedCombinedRate: 0.08875,
  }],

  [74367,{
    ZipCode: 74367,
    TaxRegionName: "SPAVINAW",
    EstimatedCombinedRate: 0.08875,
  }],

  [74368,{
    ZipCode: 74368,
    TaxRegionName: "DELAWARE",
    EstimatedCombinedRate: 0.059,
  }],

  [74369,{
    ZipCode: 74369,
    TaxRegionName: "WELCH",
    EstimatedCombinedRate: 0.095,
  }],

  [74370,{
    ZipCode: 74370,
    TaxRegionName: "WYANDOTTE",
    EstimatedCombinedRate: 0.0885,
  }],

  [74401,{
    ZipCode: 74401,
    TaxRegionName: "MUSKOGEE",
    EstimatedCombinedRate: 0.0915,
  }],

  [74402,{
    ZipCode: 74402,
    TaxRegionName: "MUSKOGEE",
    EstimatedCombinedRate: 0.0915,
  }],

  [74403,{
    ZipCode: 74403,
    TaxRegionName: "MUSKOGEE",
    EstimatedCombinedRate: 0.0915,
  }],

  [74421,{
    ZipCode: 74421,
    TaxRegionName: "BEGGS",
    EstimatedCombinedRate: 0.10583,
  }],

  [74422,{
    ZipCode: 74422,
    TaxRegionName: "BOYNTON",
    EstimatedCombinedRate: 0.0715,
  }],

  [74423,{
    ZipCode: 74423,
    TaxRegionName: "BRAGGS",
    EstimatedCombinedRate: 0.0815,
  }],

  [74425,{
    ZipCode: 74425,
    TaxRegionName: "CANADIAN",
    EstimatedCombinedRate: 0.105,
  }],

  [74426,{
    ZipCode: 74426,
    TaxRegionName: "CHECOTAH",
    EstimatedCombinedRate: 0.105,
  }],

  [74427,{
    ZipCode: 74427,
    TaxRegionName: "CHEROKEE",
    EstimatedCombinedRate: 0.0625,
  }],

  [74428,{
    ZipCode: 74428,
    TaxRegionName: "COUNCIL HILL",
    EstimatedCombinedRate: 0.0715,
  }],

  [74429,{
    ZipCode: 74429,
    TaxRegionName: "COWETA",
    EstimatedCombinedRate: 0.088,
  }],

  [74430,{
    ZipCode: 74430,
    TaxRegionName: "CROWDER",
    EstimatedCombinedRate: 0.1,
  }],

  [74431,{
    ZipCode: 74431,
    TaxRegionName: "DEWAR",
    EstimatedCombinedRate: 0.10083,
  }],

  [74432,{
    ZipCode: 74432,
    TaxRegionName: "EUFAULA",
    EstimatedCombinedRate: 0.1,
  }],

  [74434,{
    ZipCode: 74434,
    TaxRegionName: "FORT GIBSON",
    EstimatedCombinedRate: 0.1075,
  }],

  [74435,{
    ZipCode: 74435,
    TaxRegionName: "GORE",
    EstimatedCombinedRate: 0.09917,
  }],

  [74436,{
    ZipCode: 74436,
    TaxRegionName: "HASKELL",
    EstimatedCombinedRate: 0.095,
  }],

  [74437,{
    ZipCode: 74437,
    TaxRegionName: "DEWAR",
    EstimatedCombinedRate: 0.10083,
  }],

  [74438,{
    ZipCode: 74438,
    TaxRegionName: "HITCHITA",
    EstimatedCombinedRate: 0.065,
  }],

  [74439,{
    ZipCode: 74439,
    TaxRegionName: "BRAGGS",
    EstimatedCombinedRate: 0.0815,
  }],

  [74440,{
    ZipCode: 74440,
    TaxRegionName: "HASKELL",
    EstimatedCombinedRate: 0.065,
  }],

  [74441,{
    ZipCode: 74441,
    TaxRegionName: "HULBERT",
    EstimatedCombinedRate: 0.1025,
  }],

  [74442,{
    ZipCode: 74442,
    TaxRegionName: "INDIANOLA",
    EstimatedCombinedRate: 0.09,
  }],

  [74444,{
    ZipCode: 74444,
    TaxRegionName: "CHEROKEE",
    EstimatedCombinedRate: 0.0625,
  }],

  [74445,{
    ZipCode: 74445,
    TaxRegionName: "MORRIS",
    EstimatedCombinedRate: 0.10083,
  }],

  [74446,{
    ZipCode: 74446,
    TaxRegionName: "OKAY",
    EstimatedCombinedRate: 0.098,
  }],

  [74447,{
    ZipCode: 74447,
    TaxRegionName: "BEGGS",
    EstimatedCombinedRate: 0.10583,
  }],

  [74450,{
    ZipCode: 74450,
    TaxRegionName: "WAINWRIGHT",
    EstimatedCombinedRate: 0.0915,
  }],

  [74451,{
    ZipCode: 74451,
    TaxRegionName: "CHEROKEE",
    EstimatedCombinedRate: 0.0625,
  }],

  [74452,{
    ZipCode: 74452,
    TaxRegionName: "CHEROKEE",
    EstimatedCombinedRate: 0.0625,
  }],

  [74454,{
    ZipCode: 74454,
    TaxRegionName: "PORTER",
    EstimatedCombinedRate: 0.098,
  }],

  [74455,{
    ZipCode: 74455,
    TaxRegionName: "PORUM",
    EstimatedCombinedRate: 0.1015,
  }],

  [74456,{
    ZipCode: 74456,
    TaxRegionName: "OKMULGEE",
    EstimatedCombinedRate: 0.06083,
  }],

  [74457,{
    ZipCode: 74457,
    TaxRegionName: "ADAIR",
    EstimatedCombinedRate: 0.0625,
  }],

  [74458,{
    ZipCode: 74458,
    TaxRegionName: "REDBIRD",
    EstimatedCombinedRate: 0.058,
  }],

  [74459,{
    ZipCode: 74459,
    TaxRegionName: "RENTIESVILLE",
    EstimatedCombinedRate: 0.105,
  }],

  [74460,{
    ZipCode: 74460,
    TaxRegionName: "SCHULTER",
    EstimatedCombinedRate: 0.06583,
  }],

  [74461,{
    ZipCode: 74461,
    TaxRegionName: "MCINTOSH",
    EstimatedCombinedRate: 0.065,
  }],

  [74462,{
    ZipCode: 74462,
    TaxRegionName: "STIGLER",
    EstimatedCombinedRate: 0.1,
  }],

  [74463,{
    ZipCode: 74463,
    TaxRegionName: "TAFT",
    EstimatedCombinedRate: 0.0915,
  }],

  [74464,{
    ZipCode: 74464,
    TaxRegionName: "TAHLEQUAH",
    EstimatedCombinedRate: 0.095,
  }],

  [74465,{
    ZipCode: 74465,
    TaxRegionName: "TAHLEQUAH",
    EstimatedCombinedRate: 0.095,
  }],

  [74467,{
    ZipCode: 74467,
    TaxRegionName: "OKAY",
    EstimatedCombinedRate: 0.098,
  }],

  [74468,{
    ZipCode: 74468,
    TaxRegionName: "WAINWRIGHT",
    EstimatedCombinedRate: 0.0915,
  }],

  [74469,{
    ZipCode: 74469,
    TaxRegionName: "WARNER",
    EstimatedCombinedRate: 0.0915,
  }],

  [74470,{
    ZipCode: 74470,
    TaxRegionName: "WEBBERS FALLS",
    EstimatedCombinedRate: 0.1065,
  }],

  [74471,{
    ZipCode: 74471,
    TaxRegionName: "CHEROKEE",
    EstimatedCombinedRate: 0.0625,
  }],

  [74472,{
    ZipCode: 74472,
    TaxRegionName: "WHITEFIELD",
    EstimatedCombinedRate: 0.095,
  }],

  [74477,{
    ZipCode: 74477,
    TaxRegionName: "WAGONER",
    EstimatedCombinedRate: 0.098,
  }],

  [74501,{
    ZipCode: 74501,
    TaxRegionName: "SAVANNA",
    EstimatedCombinedRate: 0.11,
  }],

  [74502,{
    ZipCode: 74502,
    TaxRegionName: "MCALESTER",
    EstimatedCombinedRate: 0.0975,
  }],

  [74521,{
    ZipCode: 74521,
    TaxRegionName: "ALBION",
    EstimatedCombinedRate: 0.065,
  }],

  [74522,{
    ZipCode: 74522,
    TaxRegionName: "ALDERSON",
    EstimatedCombinedRate: 0.08,
  }],

  [74523,{
    ZipCode: 74523,
    TaxRegionName: "ANTLERS",
    EstimatedCombinedRate: 0.1,
  }],

  [74525,{
    ZipCode: 74525,
    TaxRegionName: "ATOKA",
    EstimatedCombinedRate: 0.1025,
  }],

  [74528,{
    ZipCode: 74528,
    TaxRegionName: "PITTSBURG",
    EstimatedCombinedRate: 0.06,
  }],

  [74529,{
    ZipCode: 74529,
    TaxRegionName: "PITTSBURG",
    EstimatedCombinedRate: 0.06,
  }],

  [74530,{
    ZipCode: 74530,
    TaxRegionName: "BROMIDE",
    EstimatedCombinedRate: 0.065,
  }],

  [74531,{
    ZipCode: 74531,
    TaxRegionName: "CALVIN",
    EstimatedCombinedRate: 0.095,
  }],

  [74533,{
    ZipCode: 74533,
    TaxRegionName: "CANEY",
    EstimatedCombinedRate: 0.0825,
  }],

  [74534,{
    ZipCode: 74534,
    TaxRegionName: "CENTRAHOMA",
    EstimatedCombinedRate: 0.065,
  }],

  [74535,{
    ZipCode: 74535,
    TaxRegionName: "COAL",
    EstimatedCombinedRate: 0.065,
  }],

  [74536,{
    ZipCode: 74536,
    TaxRegionName: "CLAYTON",
    EstimatedCombinedRate: 0.105,
  }],

  [74538,{
    ZipCode: 74538,
    TaxRegionName: "COALGATE",
    EstimatedCombinedRate: 0.095,
  }],

  [74540,{
    ZipCode: 74540,
    TaxRegionName: "PUSHMATAHA",
    EstimatedCombinedRate: 0.065,
  }],

  [74543,{
    ZipCode: 74543,
    TaxRegionName: "PUSHMATAHA",
    EstimatedCombinedRate: 0.065,
  }],

  [74545,{
    ZipCode: 74545,
    TaxRegionName: "LATIMER",
    EstimatedCombinedRate: 0.06,
  }],

  [74546,{
    ZipCode: 74546,
    TaxRegionName: "HAILEYVILLE",
    EstimatedCombinedRate: 0.09,
  }],

  [74547,{
    ZipCode: 74547,
    TaxRegionName: "HARTSHORNE",
    EstimatedCombinedRate: 0.0925,
  }],

  [74549,{
    ZipCode: 74549,
    TaxRegionName: "LE FLORE",
    EstimatedCombinedRate: 0.065,
  }],

  [74552,{
    ZipCode: 74552,
    TaxRegionName: "KINTA",
    EstimatedCombinedRate: 0.09,
  }],

  [74553,{
    ZipCode: 74553,
    TaxRegionName: "KIOWA",
    EstimatedCombinedRate: 0.11,
  }],

  [74554,{
    ZipCode: 74554,
    TaxRegionName: "KREBS",
    EstimatedCombinedRate: 0.1,
  }],

  [74555,{
    ZipCode: 74555,
    TaxRegionName: "ATOKA",
    EstimatedCombinedRate: 0.0625,
  }],

  [74556,{
    ZipCode: 74556,
    TaxRegionName: "LEHIGH",
    EstimatedCombinedRate: 0.085,
  }],

  [74557,{
    ZipCode: 74557,
    TaxRegionName: "PUSHMATAHA",
    EstimatedCombinedRate: 0.065,
  }],

  [74558,{
    ZipCode: 74558,
    TaxRegionName: "PUSHMATAHA",
    EstimatedCombinedRate: 0.065,
  }],

  [74559,{
    ZipCode: 74559,
    TaxRegionName: "LATIMER",
    EstimatedCombinedRate: 0.06,
  }],

  [74560,{
    ZipCode: 74560,
    TaxRegionName: "PITTSBURG",
    EstimatedCombinedRate: 0.09,
  }],

  [74561,{
    ZipCode: 74561,
    TaxRegionName: "QUINTON",
    EstimatedCombinedRate: 0.09,
  }],

  [74562,{
    ZipCode: 74562,
    TaxRegionName: "RATTAN",
    EstimatedCombinedRate: 0.1,
  }],

  [74563,{
    ZipCode: 74563,
    TaxRegionName: "RED OAK",
    EstimatedCombinedRate: 0.09,
  }],

  [74565,{
    ZipCode: 74565,
    TaxRegionName: "SAVANNA",
    EstimatedCombinedRate: 0.11,
  }],

  [74567,{
    ZipCode: 74567,
    TaxRegionName: "PUSHMATAHA",
    EstimatedCombinedRate: 0.065,
  }],

  [74569,{
    ZipCode: 74569,
    TaxRegionName: "STRINGTOWN",
    EstimatedCombinedRate: 0.0925,
  }],

  [74570,{
    ZipCode: 74570,
    TaxRegionName: "STUART",
    EstimatedCombinedRate: 0.095,
  }],

  [74571,{
    ZipCode: 74571,
    TaxRegionName: "TALIHINA",
    EstimatedCombinedRate: 0.095,
  }],

  [74572,{
    ZipCode: 74572,
    TaxRegionName: "TUPELO",
    EstimatedCombinedRate: 0.095,
  }],

  [74574,{
    ZipCode: 74574,
    TaxRegionName: "PUSHMATAHA",
    EstimatedCombinedRate: 0.065,
  }],

  [74576,{
    ZipCode: 74576,
    TaxRegionName: "ATOKA",
    EstimatedCombinedRate: 0.0625,
  }],

  [74577,{
    ZipCode: 74577,
    TaxRegionName: "LE FLORE",
    EstimatedCombinedRate: 0.065,
  }],

  [74578,{
    ZipCode: 74578,
    TaxRegionName: "WILBURTON",
    EstimatedCombinedRate: 0.095,
  }],

  [74601,{
    ZipCode: 74601,
    TaxRegionName: "PONCA CITY",
    EstimatedCombinedRate: 0.0925,
  }],

  [74602,{
    ZipCode: 74602,
    TaxRegionName: "PONCA CITY",
    EstimatedCombinedRate: 0.0925,
  }],

  [74604,{
    ZipCode: 74604,
    TaxRegionName: "PONCA CITY",
    EstimatedCombinedRate: 0.0925,
  }],

  [74630,{
    ZipCode: 74630,
    TaxRegionName: "BILLINGS",
    EstimatedCombinedRate: 0.1,
  }],

  [74631,{
    ZipCode: 74631,
    TaxRegionName: "BLACKWELL",
    EstimatedCombinedRate: 0.10417,
  }],

  [74632,{
    ZipCode: 74632,
    TaxRegionName: "BRAMAN",
    EstimatedCombinedRate: 0.09417,
  }],

  [74633,{
    ZipCode: 74633,
    TaxRegionName: "BURBANK",
    EstimatedCombinedRate: 0.0775,
  }],

  [74636,{
    ZipCode: 74636,
    TaxRegionName: "DEER CREEK",
    EstimatedCombinedRate: 0.0875,
  }],

  [74637,{
    ZipCode: 74637,
    TaxRegionName: "FAIRFAX",
    EstimatedCombinedRate: 0.0875,
  }],

  [74640,{
    ZipCode: 74640,
    TaxRegionName: "HUNTER",
    EstimatedCombinedRate: 0.0685,
  }],

  [74641,{
    ZipCode: 74641,
    TaxRegionName: "KAW CITY",
    EstimatedCombinedRate: 0.09917,
  }],

  [74643,{
    ZipCode: 74643,
    TaxRegionName: "LAMONT",
    EstimatedCombinedRate: 0.0975,
  }],

  [74644,{
    ZipCode: 74644,
    TaxRegionName: "MARLAND",
    EstimatedCombinedRate: 0.09,
  }],

  [74646,{
    ZipCode: 74646,
    TaxRegionName: "GRANT",
    EstimatedCombinedRate: 0.0575,
  }],

  [74647,{
    ZipCode: 74647,
    TaxRegionName: "NEWKIRK",
    EstimatedCombinedRate: 0.08417,
  }],

  [74650,{
    ZipCode: 74650,
    TaxRegionName: "RALSTON",
    EstimatedCombinedRate: 0.0875,
  }],

  [74651,{
    ZipCode: 74651,
    TaxRegionName: "RED ROCK",
    EstimatedCombinedRate: 0.11,
  }],

  [74652,{
    ZipCode: 74652,
    TaxRegionName: "SHIDLER",
    EstimatedCombinedRate: 0.0775,
  }],

  [74653,{
    ZipCode: 74653,
    TaxRegionName: "TONKAWA",
    EstimatedCombinedRate: 0.09917,
  }],

  [74701,{
    ZipCode: 74701,
    TaxRegionName: "DURANT",
    EstimatedCombinedRate: 0.09375,
  }],

  [74702,{
    ZipCode: 74702,
    TaxRegionName: "DURANT",
    EstimatedCombinedRate: 0.09375,
  }],

  [74720,{
    ZipCode: 74720,
    TaxRegionName: "ACHILLE",
    EstimatedCombinedRate: 0.08,
  }],

  [74721,{
    ZipCode: 74721,
    TaxRegionName: "BRYAN",
    EstimatedCombinedRate: 0.05,
  }],

  [74722,{
    ZipCode: 74722,
    TaxRegionName: "MCCURTAIN",
    EstimatedCombinedRate: 0.0625,
  }],

  [74723,{
    ZipCode: 74723,
    TaxRegionName: "BENNINGTON",
    EstimatedCombinedRate: 0.09,
  }],

  [74724,{
    ZipCode: 74724,
    TaxRegionName: "MCCURTAIN",
    EstimatedCombinedRate: 0.0625,
  }],

  [74726,{
    ZipCode: 74726,
    TaxRegionName: "BOKCHITO",
    EstimatedCombinedRate: 0.09,
  }],

  [74727,{
    ZipCode: 74727,
    TaxRegionName: "BOSWELL",
    EstimatedCombinedRate: 0.095,
  }],

  [74728,{
    ZipCode: 74728,
    TaxRegionName: "BROKEN BOW",
    EstimatedCombinedRate: 0.0925,
  }],

  [74729,{
    ZipCode: 74729,
    TaxRegionName: "DURANT",
    EstimatedCombinedRate: 0.09375,
  }],

  [74730,{
    ZipCode: 74730,
    TaxRegionName: "DURANT",
    EstimatedCombinedRate: 0.09375,
  }],

  [74731,{
    ZipCode: 74731,
    TaxRegionName: "BRYAN",
    EstimatedCombinedRate: 0.05,
  }],

  [74733,{
    ZipCode: 74733,
    TaxRegionName: "COLBERT",
    EstimatedCombinedRate: 0.09,
  }],

  [74734,{
    ZipCode: 74734,
    TaxRegionName: "MCCURTAIN",
    EstimatedCombinedRate: 0.0625,
  }],

  [74735,{
    ZipCode: 74735,
    TaxRegionName: "FORT TOWSON",
    EstimatedCombinedRate: 0.1,
  }],

  [74736,{
    ZipCode: 74736,
    TaxRegionName: "GARVIN",
    EstimatedCombinedRate: 0.0925,
  }],

  [74737,{
    ZipCode: 74737,
    TaxRegionName: "MCCURTAIN",
    EstimatedCombinedRate: 0.0625,
  }],

  [74738,{
    ZipCode: 74738,
    TaxRegionName: "CHOCTAW",
    EstimatedCombinedRate: 0.065,
  }],

  [74740,{
    ZipCode: 74740,
    TaxRegionName: "HAWORTH",
    EstimatedCombinedRate: 0.0975,
  }],

  [74741,{
    ZipCode: 74741,
    TaxRegionName: "HENDRIX",
    EstimatedCombinedRate: 0.05,
  }],

  [74743,{
    ZipCode: 74743,
    TaxRegionName: "HUGO",
    EstimatedCombinedRate: 0.1,
  }],

  [74745,{
    ZipCode: 74745,
    TaxRegionName: "IDABEL",
    EstimatedCombinedRate: 0.0925,
  }],

  [74747,{
    ZipCode: 74747,
    TaxRegionName: "KEMP",
    EstimatedCombinedRate: 0.05,
  }],

  [74748,{
    ZipCode: 74748,
    TaxRegionName: "KENEFIC",
    EstimatedCombinedRate: 0.08,
  }],

  [74750,{
    ZipCode: 74750,
    TaxRegionName: "MILLERTON",
    EstimatedCombinedRate: 0.0925,
  }],

  [74752,{
    ZipCode: 74752,
    TaxRegionName: "MCCURTAIN",
    EstimatedCombinedRate: 0.0625,
  }],

  [74753,{
    ZipCode: 74753,
    TaxRegionName: "BRYAN",
    EstimatedCombinedRate: 0.05,
  }],

  [74754,{
    ZipCode: 74754,
    TaxRegionName: "PUSHMATAHA",
    EstimatedCombinedRate: 0.065,
  }],

  [74755,{
    ZipCode: 74755,
    TaxRegionName: "CHOCTAW",
    EstimatedCombinedRate: 0.065,
  }],

  [74756,{
    ZipCode: 74756,
    TaxRegionName: "FORT TOWSON",
    EstimatedCombinedRate: 0.1,
  }],

  [74759,{
    ZipCode: 74759,
    TaxRegionName: "SOPER",
    EstimatedCombinedRate: 0.085,
  }],

  [74760,{
    ZipCode: 74760,
    TaxRegionName: "CHOCTAW",
    EstimatedCombinedRate: 0.065,
  }],

  [74761,{
    ZipCode: 74761,
    TaxRegionName: "CHOCTAW",
    EstimatedCombinedRate: 0.065,
  }],

  [74764,{
    ZipCode: 74764,
    TaxRegionName: "MILLERTON",
    EstimatedCombinedRate: 0.0925,
  }],

  [74766,{
    ZipCode: 74766,
    TaxRegionName: "WRIGHT CITY",
    EstimatedCombinedRate: 0.0925,
  }],

  [74801,{
    ZipCode: 74801,
    TaxRegionName: "SHAWNEE",
    EstimatedCombinedRate: 0.09495,
  }],

  [74802,{
    ZipCode: 74802,
    TaxRegionName: "SHAWNEE",
    EstimatedCombinedRate: 0.09495,
  }],

  [74804,{
    ZipCode: 74804,
    TaxRegionName: "MCLOUD",
    EstimatedCombinedRate: 0.09995,
  }],

  [74818,{
    ZipCode: 74818,
    TaxRegionName: "SEMINOLE",
    EstimatedCombinedRate: 0.0975,
  }],

  [74820,{
    ZipCode: 74820,
    TaxRegionName: "ADA",
    EstimatedCombinedRate: 0.09375,
  }],

  [74821,{
    ZipCode: 74821,
    TaxRegionName: "ADA",
    EstimatedCombinedRate: 0.09375,
  }],

  [74824,{
    ZipCode: 74824,
    TaxRegionName: "AGRA",
    EstimatedCombinedRate: 0.095,
  }],

  [74825,{
    ZipCode: 74825,
    TaxRegionName: "ALLEN",
    EstimatedCombinedRate: 0.085,
  }],

  [74826,{
    ZipCode: 74826,
    TaxRegionName: "ASHER",
    EstimatedCombinedRate: 0.09995,
  }],

  [74827,{
    ZipCode: 74827,
    TaxRegionName: "ATWOOD",
    EstimatedCombinedRate: 0.075,
  }],

  [74829,{
    ZipCode: 74829,
    TaxRegionName: "BOLEY",
    EstimatedCombinedRate: 0.115,
  }],

  [74830,{
    ZipCode: 74830,
    TaxRegionName: "BOWLEGS",
    EstimatedCombinedRate: 0.0875,
  }],

  [74831,{
    ZipCode: 74831,
    TaxRegionName: "BYARS",
    EstimatedCombinedRate: 0.09,
  }],

  [74832,{
    ZipCode: 74832,
    TaxRegionName: "CARNEY",
    EstimatedCombinedRate: 0.095,
  }],

  [74833,{
    ZipCode: 74833,
    TaxRegionName: "CASTLE",
    EstimatedCombinedRate: 0.095,
  }],

  [74834,{
    ZipCode: 74834,
    TaxRegionName: "CHANDLER",
    EstimatedCombinedRate: 0.095,
  }],

  [74836,{
    ZipCode: 74836,
    TaxRegionName: "JOHNSTON",
    EstimatedCombinedRate: 0.065,
  }],

  [74837,{
    ZipCode: 74837,
    TaxRegionName: "CROMWELL",
    EstimatedCombinedRate: 0.0875,
  }],

  [74839,{
    ZipCode: 74839,
    TaxRegionName: "DUSTIN",
    EstimatedCombinedRate: 0.095,
  }],

  [74840,{
    ZipCode: 74840,
    TaxRegionName: "SHAWNEE",
    EstimatedCombinedRate: 0.09495,
  }],

  [74842,{
    ZipCode: 74842,
    TaxRegionName: "PONTOTOC",
    EstimatedCombinedRate: 0.05375,
  }],

  [74843,{
    ZipCode: 74843,
    TaxRegionName: "FITZHUGH",
    EstimatedCombinedRate: 0.05375,
  }],

  [74844,{
    ZipCode: 74844,
    TaxRegionName: "FRANCIS",
    EstimatedCombinedRate: 0.08375,
  }],

  [74845,{
    ZipCode: 74845,
    TaxRegionName: "HANNA",
    EstimatedCombinedRate: 0.105,
  }],

  [74848,{
    ZipCode: 74848,
    TaxRegionName: "HOLDENVILLE",
    EstimatedCombinedRate: 0.105,
  }],

  [74849,{
    ZipCode: 74849,
    TaxRegionName: "KONAWA",
    EstimatedCombinedRate: 0.0975,
  }],

  [74850,{
    ZipCode: 74850,
    TaxRegionName: "LAMAR",
    EstimatedCombinedRate: 0.085,
  }],

  [74851,{
    ZipCode: 74851,
    TaxRegionName: "OKLAHOMA CITY",
    EstimatedCombinedRate: 0.1012,
  }],

  [74852,{
    ZipCode: 74852,
    TaxRegionName: "MACOMB",
    EstimatedCombinedRate: 0.08995,
  }],

  [74854,{
    ZipCode: 74854,
    TaxRegionName: "MAUD",
    EstimatedCombinedRate: 0.09995,
  }],

  [74855,{
    ZipCode: 74855,
    TaxRegionName: "MEEKER",
    EstimatedCombinedRate: 0.095,
  }],

  [74856,{
    ZipCode: 74856,
    TaxRegionName: "MILL CREEK",
    EstimatedCombinedRate: 0.1,
  }],

  [74857,{
    ZipCode: 74857,
    TaxRegionName: "MCLOUD",
    EstimatedCombinedRate: 0.09995,
  }],

  [74859,{
    ZipCode: 74859,
    TaxRegionName: "OKMULGEE",
    EstimatedCombinedRate: 0.105,
  }],

  [74860,{
    ZipCode: 74860,
    TaxRegionName: "PADEN",
    EstimatedCombinedRate: 0.095,
  }],

  [74864,{
    ZipCode: 74864,
    TaxRegionName: "PRAGUE",
    EstimatedCombinedRate: 0.095,
  }],

  [74865,{
    ZipCode: 74865,
    TaxRegionName: "ROFF",
    EstimatedCombinedRate: 0.09875,
  }],

  [74866,{
    ZipCode: 74866,
    TaxRegionName: "SAINT LOUIS",
    EstimatedCombinedRate: 0.05995,
  }],

  [74867,{
    ZipCode: 74867,
    TaxRegionName: "SASAKWA",
    EstimatedCombinedRate: 0.0975,
  }],

  [74868,{
    ZipCode: 74868,
    TaxRegionName: "SEMINOLE",
    EstimatedCombinedRate: 0.0975,
  }],

  [74869,{
    ZipCode: 74869,
    TaxRegionName: "SPARKS",
    EstimatedCombinedRate: 0.095,
  }],

  [74871,{
    ZipCode: 74871,
    TaxRegionName: "ADA",
    EstimatedCombinedRate: 0.09375,
  }],

  [74872,{
    ZipCode: 74872,
    TaxRegionName: "STRATFORD",
    EstimatedCombinedRate: 0.0925,
  }],

  [74873,{
    ZipCode: 74873,
    TaxRegionName: "SHAWNEE",
    EstimatedCombinedRate: 0.09495,
  }],

  [74875,{
    ZipCode: 74875,
    TaxRegionName: "TRYON",
    EstimatedCombinedRate: 0.095,
  }],

  [74878,{
    ZipCode: 74878,
    TaxRegionName: "WANETTE",
    EstimatedCombinedRate: 0.09495,
  }],

  [74880,{
    ZipCode: 74880,
    TaxRegionName: "CLEARVIEW",
    EstimatedCombinedRate: 0.105,
  }],

  [74881,{
    ZipCode: 74881,
    TaxRegionName: "WELLSTON",
    EstimatedCombinedRate: 0.095,
  }],

  [74883,{
    ZipCode: 74883,
    TaxRegionName: "WETUMKA",
    EstimatedCombinedRate: 0.105,
  }],

  [74884,{
    ZipCode: 74884,
    TaxRegionName: "SEMINOLE",
    EstimatedCombinedRate: 0.0975,
  }],

  [74901,{
    ZipCode: 74901,
    TaxRegionName: "ARKOMA",
    EstimatedCombinedRate: 0.095,
  }],

  [74902,{
    ZipCode: 74902,
    TaxRegionName: "POCOLA",
    EstimatedCombinedRate: 0.105,
  }],

  [74930,{
    ZipCode: 74930,
    TaxRegionName: "BOKOSHE",
    EstimatedCombinedRate: 0.095,
  }],

  [74931,{
    ZipCode: 74931,
    TaxRegionName: "ADAIR",
    EstimatedCombinedRate: 0.0625,
  }],

  [74932,{
    ZipCode: 74932,
    TaxRegionName: "CAMERON",
    EstimatedCombinedRate: 0.085,
  }],

  [74935,{
    ZipCode: 74935,
    TaxRegionName: "FANSHAWE",
    EstimatedCombinedRate: 0.095,
  }],

  [74936,{
    ZipCode: 74936,
    TaxRegionName: "GANS",
    EstimatedCombinedRate: 0.07917,
  }],

  [74937,{
    ZipCode: 74937,
    TaxRegionName: "HEAVENER",
    EstimatedCombinedRate: 0.1,
  }],

  [74939,{
    ZipCode: 74939,
    TaxRegionName: "LE FLORE",
    EstimatedCombinedRate: 0.065,
  }],

  [74940,{
    ZipCode: 74940,
    TaxRegionName: "HEAVENER",
    EstimatedCombinedRate: 0.1,
  }],

  [74941,{
    ZipCode: 74941,
    TaxRegionName: "KEOTA",
    EstimatedCombinedRate: 0.1,
  }],

  [74942,{
    ZipCode: 74942,
    TaxRegionName: "LEFLORE",
    EstimatedCombinedRate: 0.075,
  }],

  [74943,{
    ZipCode: 74943,
    TaxRegionName: "HASKELL",
    EstimatedCombinedRate: 0.065,
  }],

  [74944,{
    ZipCode: 74944,
    TaxRegionName: "MCCURTAIN",
    EstimatedCombinedRate: 0.1,
  }],

  [74945,{
    ZipCode: 74945,
    TaxRegionName: "MARBLE CITY",
    EstimatedCombinedRate: 0.08917,
  }],

  [74946,{
    ZipCode: 74946,
    TaxRegionName: "MOFFETT",
    EstimatedCombinedRate: 0.07917,
  }],

  [74947,{
    ZipCode: 74947,
    TaxRegionName: "LE FLORE",
    EstimatedCombinedRate: 0.065,
  }],

  [74948,{
    ZipCode: 74948,
    TaxRegionName: "ROLAND",
    EstimatedCombinedRate: 0.09917,
  }],

  [74949,{
    ZipCode: 74949,
    TaxRegionName: "LE FLORE",
    EstimatedCombinedRate: 0.065,
  }],

  [74951,{
    ZipCode: 74951,
    TaxRegionName: "PANAMA",
    EstimatedCombinedRate: 0.095,
  }],

  [74953,{
    ZipCode: 74953,
    TaxRegionName: "POTEAU",
    EstimatedCombinedRate: 0.095,
  }],

  [74954,{
    ZipCode: 74954,
    TaxRegionName: "ROLAND",
    EstimatedCombinedRate: 0.09917,
  }],

  [74955,{
    ZipCode: 74955,
    TaxRegionName: "SALLISAW",
    EstimatedCombinedRate: 0.09917,
  }],

  [74956,{
    ZipCode: 74956,
    TaxRegionName: "SHADY POINT",
    EstimatedCombinedRate: 0.1,
  }],

  [74957,{
    ZipCode: 74957,
    TaxRegionName: "LE FLORE",
    EstimatedCombinedRate: 0.065,
  }],

  [74959,{
    ZipCode: 74959,
    TaxRegionName: "FORT COFFEE",
    EstimatedCombinedRate: 0.095,
  }],

  [74960,{
    ZipCode: 74960,
    TaxRegionName: "STILWELL",
    EstimatedCombinedRate: 0.1,
  }],

  [74962,{
    ZipCode: 74962,
    TaxRegionName: "VIAN",
    EstimatedCombinedRate: 0.09917,
  }],

  [74963,{
    ZipCode: 74963,
    TaxRegionName: "MCCURTAIN",
    EstimatedCombinedRate: 0.0625,
  }],

  [74964,{
    ZipCode: 74964,
    TaxRegionName: "WEST SILOAM SPRINGS",
    EstimatedCombinedRate: 0.1065,
  }],

  [74965,{
    ZipCode: 74965,
    TaxRegionName: "WESTVILLE",
    EstimatedCombinedRate: 0.1,
  }],

  [74966, {
    ZipCode: 74966,
    TaxRegionName: "FANSHAWE",
    EstimatedCombinedRate: 0.095,
  }],
]);

export default TAX_RATE_LIST;
